<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="68%"
    :close-on-click-modal="false"
    :before-close="handleClose"
    top="2vh"
    custom-class="addxyk-dialog"
  >
    <el-form
      ref="inboundForm"
      :model="formData"
      :rules="formRules"
      label-position="top"
      size="small"
      v-loading="loading"
    >
      <!-- ===== 出库基本信息 ===== -->
      <div class="basic-info-section">
        <div class="section-header">
          <h4 class="section-title">出库基本信息</h4>
          <p class="section-desc">
            当前操作为：药库进行出库，草稿可进行查询编辑修改，当提交完成后会进行’审核，过单‘等流程，当完成过单后，出库完成。
          </p>
        </div>

        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="出库类型" prop="retnTypeId" required>
              <el-select
                v-model="formData.retnTypeId"
                placeholder="请选择出库类型"
                style="width:100%"
                :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"
              >
                <el-option
                  v-for="typed in computedPutinTypeList"
                  :key="typed.id"
                  :label="typed.name"
                  :value="typed.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="出库科室" prop="deptId" required>
              <el-select
                v-model="formData.deptId"
                placeholder="请选择出库科室"
                clearable
                style="width:100%"
                :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"
              >
                <el-option
                  v-for="item in deptOptions"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="业务日期" prop="businessDate" required>
              <el-date-picker
                v-model="formData.businessDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                style="width:100%"
                :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="供货单位" prop="supplierId" required>
              <div class="supplier-wrapper">
                <el-select
                  v-model="formData.supplierId"
                  placeholder="请选择供货单位"
                  @change="handleSupplierChange"
                  :loading="supplierLoading"
                  style="flex:1;"
                  :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"
                >
                  <el-option
                    v-for="item in supplierList"
                    :key="item.id"
                    :label="item.supplierName"
                    :value="item.id"
                  >
                    <div class="supplier-option">
                      <span>{{ item.supplierName }}</span>
                    </div>
                  </el-option>
                </el-select>
                <el-button
                  v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode && !isFastMode"
                  type="primary"
                  icon="el-icon-plus"
                  size="mini"
                  @click="handleAddSupplier"
                  class="add-supplier-btn"
                  title="添加新的供应商"
                ></el-button>
                <el-input
                  v-model="formData.supplierCode"
                  placeholder="供货单号"
                  class="supplier-code-input"
                  :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="formData.remark"
                type="textarea"
                :rows="2"
                placeholder="请输入备注信息"
                :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- ===== 药品明细信息 ===== -->
      <div class="medicine-detail-section">
        <div class="section-header">
          <h4 class="section-title">药品明细信息</h4>
          <div class="right-function-buttons">
            <div v-if="mode === 'add' || mode === 'edit'" class="scan-input-wrapper" style="display:inline-block; margin-right:10px;">
              <el-input
                v-model="outerScanInput"
                placeholder="请使用扫码枪扫描追溯码"
                clearable
                size="mini"
                @keyup.enter="handleOuterScanConfirm"
              >
                <template slot="append">
                  <el-button
                    type="primary"
                    icon="el-icon-Ssearch"
                    @click="handleOuterScanConfirm"
                    size="mini"
                    :loading="outerScanLoading"
                    :disabled="!outerScanInput || outerScanInput.trim() === ''"
                  >查询</el-button>
                </template>
              </el-input>
            </div>
            <el-button
              v-if="mode === 'add' || mode === 'edit'"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAddMedicine"
            >添加药品</el-button>
          </div>
        </div>

        <el-table
          :data="medicineList"
          style="width:100%"
          border
          size="mini"
          height="300"
          empty-text="暂无药品明细，请点击上方【添加药品】按钮"
        >
          <el-table-column type="index" label="#" width="50" align="center"></el-table-column>

          <el-table-column width="160" align="center">
            <template slot="header">
              <span style="color:red;">*</span> 药品名称
            </template>
            <template slot-scope="scope">
              <div class="drug-select-container" :key="scope.row.id || scope.$index">
                <template v-if="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
                  <span>{{ scope.row.drugName || '--' }}</span>
                </template>
                <template v-else>
                  <el-select
                    v-model="scope.row.drugId"
                    filterable
                    placeholder="请选择药品"
                    size="mini"
                    style="width:100%"
                    @change="handleDrugChange(scope.row)"
                    clearable
                    :clearable="canClearDrug(scope.row)"
                    @clear="handleDrugClear(scope.row)"
                    remote
                    :remote-method="(query) => handleDrugSearch(query, scope.row)"
                    :remote="canRemoteSearch(scope.row)"
                    :loading="scope.row.drugLoading"
                    @focus="handleDrugFocus(scope.row)"
                    v-el-select-infinite-scroll="() => handleDrugScroll(scope.row)"
                    popper-class="drug-select-popper"
                    :disabled="!canSelectDrug(scope.row) || (scope.row.isLocked && mode !== 'add' && mode !== 'edit')"
                  >
                    <el-option
                      v-for="drug in getDrugOptionsForRow(scope.row)"
                      :key="drug.id || drug.drugId"
                      :label="getDrugDisplayLabel(drug, scope.row)"
                      :value="drug.drugId || drug.id"
                    >
                      <div class="drug-option">
                        <div style="display:flex; align-items:center; gap:6px; flex-wrap:wrap;">
                          <el-tag
                            size="mini"
                            :type="getDrugTypeTagType(drug.drugType)"
                            style="flex-shrink:0;"
                          >
                            {{ getDrugTypeText(drug.drugType) }}
                          </el-tag>
                          <span class="drug-name" v-html="getHighlightedDrugName(drug, scope.row)"></span>
                        </div>
                        <template v-if="drug.drugSpec || drug.pacSpec || scope.row.spec">
                          <span class="drug-spec">规格：{{ drug.drugSpec || drug.pacSpec || scope.row.spec || '' }}</span>
                        </template>
                        <template v-if="drug.prodentpName || scope.row.manufacturer">
                          <span class="drug-spec">生产厂家：{{ drug.prodentpName || scope.row.manufacturer || '' }}</span>
                        </template>
                      </div>
                    </el-option>
                    <div v-if="showNoSearchResults(scope.row)" slot="empty" class="no-search-results">
                      <i class="el-icon-Ssearch"></i>
                      <span>未找到"{{ scope.row ? scope.row.drugSearchQuery : this.drugSearchQuery }}"相关药品</span>
                    </div>
                    <el-option
                      v-if="drugHasMore && !drugSearchLoading && canLoadMore(scope.row)"
                      :key="`load-more-${scope.row.id}-${Date.now()}`"
                      value="load-more"
                      label="点击加载更多"
                      @click.native="loadMoreDrugs(scope.row)"
                    >
                      <div class="load-more-option" @click.stop="loadMoreDrugs(scope.row)">
                        <i class="el-icon-loading" v-if="loadingMoreDrugs"></i>
                        <span v-else>点击加载更多</span>
                      </div>
                    </el-option>
                  </el-select>
                </template>
              </div>
            </template>
          </el-table-column>

          <el-table-column width="120" align="center">
            <template slot="header">
              <span style="color:red;">*</span> 出库数量
            </template>
            <template slot-scope="scope">
              <div class="qty-wrapper">
                <el-input
                  v-model="scope.row.outQuantity"
                  size="mini"
                  @input="handleQuantityInput(scope.row, $event)"
                  class="qty-input"
                  :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode || (scope.row.isLocked && mode !== 'add' && mode !== 'edit')"
                ></el-input>
                <span class="unit-label">{{ scope.row.unitLabel || '' }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column width="100" align="center">
            <template slot="header">
              <span style="color:red;">*</span> 库存类型
            </template>
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.stockType"
                placeholder="类型"
                size="mini"
                @change="handleStockTypeChange(scope.row)"
                style="width:100%"
                :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode || (scope.row.isLocked && mode !== 'edit')"
              >
                <el-option label="最小单位" :value="1"></el-option>
                <el-option label="包装单位" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="pacCnt" width="100" align="center">
            <template slot="header">包装数量</template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.pacCnt" size="mini" disabled></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="purcCnt" width="120" align="center">
            <template slot="header">实际库存数量</template>
            <template slot-scope="scope">
              <span>{{ scope.row.purcCnt || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="currentOutCost" width="120" align="center">
            <template slot="header">
              <span style="color:red;">*</span> 出库成本
            </template>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.currentOutCost"
                size="mini"
                placeholder="0.00"
                @input="handleOutCostInput(scope.row, $event)"
                :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="currentOutSale" width="120" align="center">
            <template slot="header">出库零售</template>
            <template slot-scope="scope">
              <span>¥{{ scope.row.currentOutSale ? formatDecimal(scope.row.currentOutSale, 8) : '0.00' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="prodentpName" width="140" align="center">
            <template slot="header">生产厂商</template>
            <template slot-scope="scope">
              <span>{{ scope.row.prodentpName || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="manuLotnum" width="120" align="center">
            <template slot="header">批次号</template>
            <template slot-scope="scope">
              <span>{{ scope.row.manuLotnum || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="purcPric" width="120" align="center">
            <template slot="header">入库成本</template>
            <template slot-scope="scope">
              <span>¥{{ scope.row.purcPric ? formatDecimal(scope.row.purcPric, 8) : '0.00' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="salePric" width="120" align="center">
            <template slot="header">入库零售</template>
            <template slot-scope="scope">
              <span>¥{{ scope.row.salePric ? formatDecimal(scope.row.salePric, 8) : '0.00' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="isFixedPriceText" width="100" align="center">
            <template slot="header">指定售价</template>
            <template slot-scope="scope">
              <span>{{ scope.row.isFixedPriceText || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="manuDate" width="120" align="center">
            <template slot="header">生产日期</template>
            <template slot-scope="scope">
              <span>{{ scope.row.manuDate || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="expyDate" width="120" align="center">
            <template slot="header">有效期</template>
            <template slot-scope="scope">
              <span>{{ scope.row.expyDate || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="drugSpec" width="100" align="center" show-overflow-tooltip>
            <template slot="header">规格</template>
            <template slot-scope="scope">
              <span>{{ scope.row.drugSpec || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode && !isFastMode"
            label="操作"
            width="140"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.isBar === 1" :content="getTraceCodeTooltip(scope.row)" placement="top">
                <span style="display:inline-block;">
                  <el-button
                    v-if="scope.row.isBar === 1"
                    type="text"
                    size="mini"
                    @click="openTraceCodeSupplement(scope.row, scope.$index)"
                    :disabled="!canTraceCode(scope.row)"
                    style="margin-right:5px;"
                  >{{ scope.row.traceCodeButtonText || '追溯码' }}</el-button>
                </span>
              </el-tooltip>
              <el-button
                type="text"
                size="mini"
                style="color:#F56C6C;"
                @click="handleRemoveMedicine(scope.$index, scope.row)"
              >移除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="summary-info">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">药品数量：</span>
                <span class="value">{{ medicineList.length }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">总出库数量：</span>
                <span class="value">{{ totalOutQuantity }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">总出库成本：</span>
                <span class="value">¥{{ formatCurrency(totalOutCost) }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">总出库零售：</span>
                <span class="value">¥{{ formatCurrency(totalOutSale) }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <!-- ===== 底部按钮 ===== -->
    <span slot="footer" class="dialog-footer">
      <template v-if="isViewMode">
        <el-button size="small" @click="handleClose">关闭</el-button>
      </template>
      <!-- ===== add 模式：根据「库存审核流程开关」动态显示按钮 ===== -->
      <template v-else-if="mode === 'add'">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="handleCreate" :loading="saving" :disabled="medicineList.length === 0">确认创建</el-button>
        <!-- 未启用审核流程（value=0）时显示"保存提交"；启用审核流程（value=1）时不显示 -->
        <el-button
          v-if="!inventoryAuditFlowEnabled"
          type="success"
          size="small"
          @click="handleCreateAndSubmit"
          :loading="saving"
          :disabled="medicineList.length === 0"
        >保存提交</el-button>
      </template>
      <!-- ===== edit 模式：修改保存 / 保存提交（都走 editdocOut，仅 state 不同） ===== -->
      <template v-else-if="mode === 'edit'">
        <el-button type="primary" size="small" @click="handleSave" :loading="saving">修改保存</el-button>
        <el-button type="success" size="small" @click="handleSaveAndSubmit" :loading="saving">保存提交</el-button>
      </template>
      <template v-else-if="mode === 'submit'">
        <el-button size="small" @click="handleClose">关闭</el-button>
        <el-button type="primary" size="small" @click="handleSubmitConfirm" :loading="saving">确认提交</el-button>
      </template>
      <template v-else-if="mode === 'review'">
        <el-button size="small" @click="handleClose">关闭</el-button>
        <el-button type="warning" size="small" @click="handleRollbackDraft" :loading="saving">回退草稿</el-button>
        <el-button type="primary" size="small" @click="handleReviewConfirm" :loading="saving">确认审核</el-button>
      </template>
      <template v-else-if="mode === 'pass'">
        <el-button size="small" @click="handleClose">关闭</el-button>
        <el-button type="warning" size="small" @click="handleRollbackReview" :loading="saving">回退审核</el-button>
        <el-button type="success" size="small" @click="handlePassConfirm" :loading="saving">确认出库</el-button>
      </template>
      <template v-else-if="mode === 'rollback'">
        <el-button size="small" @click="handleClose">关闭</el-button>
        <el-button type="warning" size="small" @click="handleRollbackConfirm" :loading="saving">确认回退</el-button>
      </template>
      <template v-else-if="mode === 'fast'">
        <el-button size="small" @click="handleClose">关闭</el-button>
        <el-button type="primary" size="small" @click="handleFastTransferConfirm" :loading="saving">确认无误，快速调拨</el-button>
      </template>
    </span>

    <!-- ===== 新增供货单位 ===== -->
    <el-dialog 
      title="新增供货单位" 
      :visible.sync="supplierDialogVisible" 
      width="720px" 
      :close-on-click-modal="false" 
      custom-class="supplier-dialog"
      top="10vh"
    >
      <el-form ref="supplierForm" :model="supplierForm" :rules="supplierRules" label-width="130px" size="small" class="supplier-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人：" prop="contact">
              <el-input v-model="supplierForm.contact" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人电话：" prop="contactPhone">
              <el-input v-model="supplierForm.contactPhone" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="供货商名称：" prop="supplierName" required>
          <el-input v-model="supplierForm.supplierName" placeholder=""></el-input>
        </el-form-item>
    
        <el-form-item label="供货商地址：" prop="address">
          <el-input v-model="supplierForm.address" placeholder=""></el-input>
        </el-form-item>
    
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="期初金额：" prop="payAmt">
              <el-input-number v-model="supplierForm.payAmt" style="width: 100%;" :controls="true" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态：" prop="status">
              <el-select v-model="supplierForm.status" placeholder="请选择状态" style="width:100%">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
    
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="码上放心企业ID：" prop="entId">
              <el-input v-model="supplierForm.entId" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业唯一标识：" prop="creditCode">
              <el-input v-model="supplierForm.creditCode" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
    
        <el-form-item label="许可证号：" prop="permitNumber">
          <el-input v-model="supplierForm.permitNumber" type="textarea" :rows="2" placeholder=""></el-input>
        </el-form-item>
    
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="supplierForm.remark" type="textarea" :rows="2" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleSaveSupplier" :loading="supplierSaving">保存</el-button>
        <el-button size="small" @click="supplierDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="traceCodeDialogTitle"
      :visible.sync="traceCodeDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :before-close="handleTraceCodeDialogClose"
      top="5vh"
      custom-class="trace-code-dialog"
    >
      <div class="dialog-header" slot="title">
        <span class="dialog-title-text">{{ traceCodeDialogTitle }}</span>
      </div>
      <div class="trace-code-dialog-content">
        <div class="function-buttons-section">
          <div class="function-button-group">
            <div class="left-function-area">
              <div class="scan-input-area">
                <h4 class="scan-area-title">扫码枪录入区域</h4>
                <div class="scan-input-wrapper">
                  <el-input
                    v-model="scanInput"
                    placeholder="请使用扫码枪扫描追溯码，按回车键确认"
                    clearable
                    @keyup.enter="handleScanInput"
                    size="small"
                    style="width:100%;"
                  >
                    <template slot="append">
                      <el-button type="primary" icon="el-icon-guahao" @click="handleScanInput" size="small">确认</el-button>
                    </template>
                  </el-input>
                </div>
                <div class="scan-tips">
                  <i class="el-icon-info"></i> 提示：扫描追溯码后按回车键或点击确认按钮
                </div>
              </div>
            </div>
            <div class="right-function-area">
              <el-tooltip content="清空所有追溯码" placement="top">
                <div class="function-button-item" @click="handleClearTraceCode">
                  <i class="el-icon-delete function-icon"></i>
                  <span class="function-text">清空</span>
                </div>
              </el-tooltip>
              <el-tooltip content="导入追溯码" placement="top">
                <div class="function-button-item" @click="handleImportTraceCode">
                  <i class="el-icon-upload2 function-icon"></i>
                  <span class="function-text">导入</span>
                </div>
              </el-tooltip>
              <el-tooltip content="导出追溯码" placement="top">
                <div class="function-button-item" @click="handleExportTraceCode">
                  <i class="el-icon-download function-icon"></i>
                  <span class="function-text">导出</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div class="summary-info-section" v-if="currentTraceMedicine">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">药品名称：</span>
                <span class="value">{{ currentTraceMedicine.drugName || '--' }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">出库数量：</span>
                <span class="value">{{ currentTraceMedicine.outQuantity || 0 }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">包装数量：</span>
                <span class="value">{{ currentTraceMedicine.pacCnt || 0 }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">已录入数量：</span>
                <span class="value" :class="{ 'warning': totalTraceQty !== currentTraceMedicine.outQuantity }">
                  {{ totalTraceQty }}
                  <span v-if="totalTraceQty !== currentTraceMedicine.outQuantity" style="color: #E6A23C; margin-left:5px;">
                    (还需录入 {{ currentTraceMedicine.outQuantity - totalTraceQty }} 个)
                  </span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="trace-code-table-section">
          <el-table
            :data="traceCodeList"
            style="width:100%"
            border
            size="mini"
            height="300"
            v-loading="traceCodeLoading"
            class="trace-code-table"
          >
            <el-table-column label="操作" width="80" align="center" fixed="left">
              <template slot-scope="scope">
                <el-button type="text" size="mini" icon="el-icon-setting" @click="handleTraceCodeSetting(scope.row, scope.$index)" title="设置"></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="traceCode" label="追溯码" min-width="200" align="center" fixed="left">
              <template slot-scope="scope">
                <el-input v-model="scope.row.traceCode" placeholder="请输入追溯码" size="mini" clearable @blur="validateTraceCode(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="drugName" label="药品名称" min-width="150" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.drugName || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="spec" label="规格" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.spec || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="availableQty" label="可用数量" width="100" align="center">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.availableQty"
                  :min="1"
                  :max="getMaxAvailableQty(scope.row)"
                  :step="1"
                  size="mini"
                  style="width:100%"
                  @change="handleAvailableQtyChange(scope.row)"
                ></el-input-number>
                <div v-if="scope.row.availableQty > getMaxAvailableQty(scope.row)" style="color:#F56C6C;font-size:12px;">超出最大数量</div>
              </template>
            </el-table-column>
            <el-table-column prop="manufacturer" label="生产厂家" width="150" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.manufacturer || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="approvalLicenceNo" label="批准文号" width="150" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.approvalLicenceNo || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="batchNo" label="生产批号" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.batchNo || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="produceDate" label="生产日期" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.produceDate || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="expireDate" label="有效期" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.expireDate || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="codeStatus" label="码状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="getCodeStatusType(scope.row.codeStatus)" size="mini">{{ scope.row.codeStatus || '--' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="150" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.remark" placeholder="请输入备注" size="mini" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" style="color:#F56C6C;" @click="handleRemoveTraceCode(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="trace-code-dialog-footer">
        <el-button size="small" @click="handleCancelTraceCode">取消</el-button>
        <el-button type="primary" size="small" @click="handleConfirmTraceCode" :loading="traceCodeLoading" :disabled="!canConfirmTraceCode">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="追溯码补录"
      :visible.sync="traceCodeSupplementDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      top="5vh"
      @close="handleCancelTraceCodeSupplement"
    >
      <div class="trace-code-supplement-dialog-content">
        <div class="add-button-section">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddSupplementTraceCode">添加新的追溯码</el-button>
        </div>
        <div class="trace-code-table-section">
          <el-table :data="traceCodeSupplementList" style="width:100%" border size="mini" height="300">
            <el-table-column prop="traceCode" label="追溯码" min-width="200" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.traceCode"
                  placeholder="请输入追溯码"
                  size="mini"
                  clearable
                  :disabled="!scope.row.isEditing"
                  @blur="handleTraceCodeBlur(scope.row, scope.$index)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="drugName" label="药品名称" width="150" align="center">
              <template slot-scope="scope"><span>{{ scope.row.drugName }}</span></template>
            </el-table-column>
            <el-table-column prop="spec" label="规格" width="120" align="center">
              <template slot-scope="scope"><span>{{ scope.row.spec }}</span></template>
            </el-table-column>
            <el-table-column prop="availableQty" label="可用数量" width="150" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.availableQty"
                  size="mini"
                  style="width:100%"
                  :disabled="!canEditAvailableQty(scope.row)"
                  @change="handleAvailableQtyChange(scope.row, scope.$index)"
                  @blur="handleAvailableQtyBlur(scope.row, scope.$index)"
                ></el-input>
                <div v-if="currentTraceMedicine && currentTraceMedicine.pacCnt" class="available-qty-tip">包装数量: {{ currentTraceMedicine.pacCnt }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="manufacturer" label="生产厂家" width="150" align="center">
              <template slot-scope="scope"><span>{{ scope.row.manufacturer }}</span></template>
            </el-table-column>
            <el-table-column prop="batchNo" label="生产批号" width="150" align="center">
              <template slot-scope="scope"><span>{{ scope.row.batchNo }}</span></template>
            </el-table-column>
            <el-table-column prop="produceDate" label="生产日期" width="120" align="center">
              <template slot-scope="scope"><span>{{ scope.row.produceDate }}</span></template>
            </el-table-column>
            <el-table-column prop="expireDate" label="有效期" width="120" align="center">
              <template slot-scope="scope"><span>{{ scope.row.expireDate }}</span></template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center" fixed="right">
              <template slot-scope="scope">
                <template v-if="scope.row.isEditing">
                  <el-button type="text" size="mini" style="color:#909399;" @click="handleCancelSupplementEdit(scope.$index)">取消</el-button>
                  <el-button type="text" size="mini" style="color:#409EFF;margin-left:5px;" @click="handleSaveSupplementRow(scope.$index)">保存</el-button>
                </template>
                <template v-else>
                  <el-button type="text" size="mini" style="color:#409EFF;" @click="handleEditSupplementRow(scope.$index)">编辑</el-button>
                  <el-button type="text" size="mini" style="color:#F56C6C;margin-left:5px;" @click="handleRemoveSupplementRow(scope.$index)">移除</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancelTraceCodeSupplement">取消</el-button>
        <el-button type="primary" size="small" @click="handleConfirmTraceCodeSupplement">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="追溯码录入"
      :visible.sync="traceCodeInputDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      top="5vh"
      class="trace-code-input-dialog"
      @close="handleCloseTraceCodeInput"
    >
      <div class="trace-code-input-dialog-content">
        <div class="medicine-form-section" v-if="traceCodeDetailData">
          <h4 class="section-title">药品信息（追溯码：{{ traceCodeInputForm.traceCode || '无' }}）</h4>
          <el-descriptions :column="2" border size="small" class="trace-code-descriptions">
            <el-descriptions-item label="药品名称" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.drugName" placeholder="药品名称" :disabled="true" class="description-content"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="规格" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.spec" disabled class="description-content"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="批准文号" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.approvalLicenceNo" placeholder="批准文号" :disabled="true" class="description-content"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="包装数量" label-class-name="description-label">
              <el-input-number v-model="traceCodeInputForm.pacCnt" :min="1" :step="1" size="small" class="description-content" :disabled="true"></el-input-number>
            </el-descriptions-item>
            <el-descriptions-item label="生产厂家" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.manufacturer" placeholder="生产厂家" :disabled="true" class="description-content"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="生产批号" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.manuLotnum" :disabled="true" class="description-content"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="有效期" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.expireDate" :disabled="true" class="description-content"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="生产日期" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.produceDate" :disabled="true" class="description-content"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="剂型" label-class-name="description-label">
              <el-input v-model="traceCodeInputForm.dosageFormName" disabled class="description-content"></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div v-if="getSomeWareLoading" class="loading-section">
          <i class="el-icon-loading"></i>
          <span>正在查询药品信息...</span>
        </div>
      </div>
      <span slot="footer" class="trace-code-dialog-footer">
        <el-button size="small" @click="handleCancelTraceCodeInput">取消</el-button>
        <el-tooltip v-if="showBottomAddButton" :content="getAddButtonTooltip()" placement="top" :disabled="!isAddButtonDisabled">
          <el-button type="warning" size="small" @click="openAddDrugDialog()" :disabled="isAddButtonDisabled">去添加</el-button>
        </el-tooltip>
        <el-button type="primary" size="small" @click="handleConfirmTraceCodeInput" :loading="traceCodeLoading" :disabled="!canConfirmTraceCodeInput">确定</el-button>
      </span>
    </el-dialog>

    <!-- ===== 过单进度 / 提交上传进度 模态框 ===== -->
    <el-dialog
      title="追溯码上传进度"
      :visible.sync="passProgressDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="trace-code-upload-dialog"
    >
      <div class="upload-progress-dialog">
        <el-steps 
          :active="traceCodeUploadStep" 
          align-center
          finish-status="success"
          class="upload-steps"
        >
          <el-step
            v-for="(step, index) in traceCodeUploadSteps"
            :key="index"
            :title="step.title"
            :description="step.description"
            :status="getStepStatus(index)"
          />
        </el-steps>

        <div v-if="uploadResultType" class="upload-result-banner" :class="uploadResultType">
          <div class="result-row">
            <i :class="uploadResultType === 'success' ? 'el-icon-success' : 'el-icon-error'"></i>
            <span class="result-text">
              <template v-if="uploadResultType === 'success'">
                追溯码上传成功！ <span class="check-mark">√</span>
              </template>
              <template v-else>
                <span class="error-title">追溯码上传失败！</span>
                <span class="error-msg">{{ uploadResultMessage || '未知错误' }}</span>
                <span class="result-tip">您可：</span>
              </template>
            </span>
          </div>
        </div>

        <div class="upload-details">
          <div class="details-title">上传详情：</div>
          <div 
            class="details-content" 
            ref="uploadDetailsContainer"
            style="max-height: 200px; overflow-y: auto;"
          >
            <div 
              v-for="(detail, index) in traceCodeUploadDetails" 
              :key="index"
              class="detail-item"
              :class="detail.type"
            >
              <i :class="getDetailIcon(detail.type)"></i>
              <span>{{ detail.message }}</span>
              <span class="detail-time">{{ detail.time }}</span>
            </div>
          </div>
        </div>
        
        <div v-if="traceCodeUploadStep < traceCodeUploadSteps.length" class="upload-progress">
          <el-progress
            :percentage="uploadProgress"
            :status="uploadStatus"
            :show-text="false"
          />
        </div>
      </div>
      
      <template slot="footer" class="upload-dialog-footer">
        <div v-if="slowResponseShown && msfxUploading">
          <el-button
            type="text"
            size="small"
            style="color:#E6A23C;"
            @click="handleSlowResponseClick"
          >响应过慢，稍后重试</el-button>
        </div>
        <div v-else-if="showErrorOptions">
          <el-button
            type="text"
            size="small"
            style="color:#409EFF;margin-right:20px;"
            @click="handleCheckBill"
          >检查单据</el-button>
          <el-button
            type="text"
            size="small"
            style="color:#67C23A;"
            @click="handleContinuePass"
          >{{ isSubmitUploadMode ? '继续提交' : '继续过单' }}</el-button>
        </div>
        <div v-else-if="traceCodeHasError && !msfxUploading && !showErrorOptions">
          <el-button @click="closeTraceCodeUploadDialog" type="primary">我已知晓</el-button>
        </div>
        <div v-else-if="traceCodeUploadStep === 4 && !traceCodeHasError && msfxUploadSuccess">
          <!-- 自动关闭 -->
        </div>
        <div v-else>
          <el-button @click="handleUploadCancel">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  selectDropDownList,
  selectDrug,
  addOutbound,
  toRetnExamine,
  editdocOut,
  selectOut,
  docOutJoin
} from "@/api/PSI/shopReturn.js";
import { addSupplierEntity, docMarkById } from "@/api/PSI.js";
import { getSystemList } from "@/api/systemParameter/systemParameter";
import { findAttribute } from "@/api/user.js";
import {
  msfxCodeDetail,
  msfxUploadInoutBill,
  getSomeWare
} from "@/api/systemCatalogue/Western.js";
import { fastTransfer } from "@/api/systemCatalogue/Western.js";

const elSelectInfiniteScroll = {
  bind(el, binding) {
    const SELECTWRAPPER_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if (SELECTWRAPPER_DOM) {
      SELECTWRAPPER_DOM.addEventListener('scroll', function() {
        const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    }
  }
};
const elTooltip = {
  inserted(el, binding) {
    el.setAttribute('title', binding.value);
  }
};

export default {
  name: 'AddxykModal',
  directives: {
    'el-select-infinite-scroll': elSelectInfiniteScroll,
    'el-tooltip': elTooltip
  },
  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: 'add' },
    rowData: { type: Object, default: () => ({}) },
    putinTypeList: { type: Array, default: () => [] }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      saving: false,
      supplierLoading: false,
      supplierSaving: false,
      supplierDialogVisible: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      quantityDebounceTimer: null,
      maxDecimalPlaces: 8,
      defaultDrugOptions: [],
      searchTimer: null,
      drugSearchLoading: false,
      loadingMoreDrugs: false,
      drugOptions: [],
      drugPageNum: 1,
      drugPageSize: 50,
      drugHasMore: true,
      drugSearchQuery: '',
      allDrugOptions: [],
      putinTypeListLocal: [],

      // ===== 库存审核流程开关 =====
      // true: 启用审核流程（value=1）→ add 模式只显示"取消 / 确认创建"
      // false: 未启用审核流程（value=0）→ add 模式显示"取消 / 确认创建 / 保存提交"
      // 默认 true（保持原有流程），加载参数后以服务端配置为准
      inventoryAuditFlowEnabled: true,

      // ===== 提交前上传追溯码模式（新增）=====
      isSubmitUploadMode: false,
      submitOperationType: null,
      submitValidList: null,

      formData: {
        warehouseId: 1,
        businessDate: new Date().toISOString().split('T')[0],
        invoiceNo: '',
        supplierId: '',
        entId: '',
        supplierCode: '',
        retnTypeId: 11,
        deptId: '',
        remark: ''
      },
      formRules: {
        supplierId: [{ required: true, message: '请选择供货单位', trigger: 'change' }],
        retnTypeId: [{ required: true, message: '请选择出库类型', trigger: 'change' }],
        deptId: [{ required: true, message: '请选择出库科室', trigger: 'change' }]
      },

      supplierForm: {
        address: "", clinicId: 0, contact: "", contactPhone: "", id: 0,
        payAmt: 0, permitNumber: "", entId: "", receAmt: 0, remark: "",
        status: '1', supplierName: ""
      },
      supplierRules: {
        supplierName: [{ required: true, message: '供应商名称为必填项', trigger: 'blur' }],
        contact: [{ required: true, message: '联系人为必填项', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '联系人电话为必填项', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      supplierList: [],
      deptOptions: [],

      medicineList: [],
      totalOutQuantity: 0,
      totalOutCost: 0,
      totalOutSale: 0,

      currentSearchKeyword: '',
      highlightColor: '#ff6700',

      traceCodeDialogVisible: false,
      currentTraceMedicine: null,
      traceCodeList: [],
      traceCodeDialogTitle: '追溯码录入',
      traceCodeLoading: false,
      scanInput: '',
      totalTraceQty: 0,

      traceCodeSupplementDialogVisible: false,
      traceCodeSupplementList: [],

      traceCodeInputDialogVisible: false,
      traceCodeInputForm: {
        traceCode: '',
        drugName: '',
        spec: '',
        inboundQty: 1,
        purcType: 2,
        pacCnt: 1,
        manuLotnum: '',
        manufacturer: '',
        manufacturerId: '',
        approvalLicenceNo: '',
        produceDate: '',
        expireDate: '',
        refEntId: '',
        remark: '',
        dosageFormName: '',
        pacUnt: '',
        dosUnt: ''
      },
      traceCodeDetailData: null,
      getSomeWareData: null,
      getSomeWareLoading: false,
      outerScanInput: '',
      outerScanLoading: false,
      showBottomAddButton: false,

      addDrugDialogVisible: false,
      addDrugDialogData: {
        drugName: '', spec: '', pacCnt: 1,
        approvalLicenceNo: '', manufacturer: '', remark: ''
      },

      systemParameterList: [],
      msfxEntId: '',
      systemParameterLoading: false,

      // ===== 过单进度（核心状态） =====
      passProgressDialogVisible: false,
      traceCodeUploadStep: 0,
      traceCodeUploadSteps: [
        { title: '检查追溯码', description: '正在检查是否有药品需要录入追溯码...', status: '' },
        { title: '接入码上放心', description: '正在接入码上放心平台接口...', status: '' },
        { title: '上传追溯码', description: '正在上传出库明细追溯码数据...', status: '' },
        { title: '完成上传', description: '追溯码已上传至码上放心平台。', status: '' },
        { title: '完成出库', description: '已完成出库。', status: '' }
      ],
      traceCodeUploadDetails: [],
      traceCodeHasError: false,
      showRetryButton: false,
      uploadRetryCount: 0,
      msfxUploading: false,
      autoCloseTimer: null,
      msfxUploadError: '',
      msfxUploadSuccess: true,

      uploadResultType: '',
      uploadResultMessage: '',
      showErrorOptions: false,
      slowResponseShown: false,
      slowResponseTimer: null,
      slowResponseCancelled: false,
      userActionResolve: null,
      passContinuing: false,

      passCurrentStep: 0,
      passLoading: false,
      needUploadTraceCode: false,
      traceCodeCount: 0,
      traceCodeString: '',
      needUploadDrugs: [],
      progressTimer: null,
      totalProgress: 0,
      showCloseButton: false,

      allowReselectAll: false,
      originalDrugDetails: null,
      adminModeWindow: false,
      adminKeyHandler: null,
      pendingTraceCode: '',
      adminTestDialogVisible: false,
      adminTestList: [],
      adminTestLoading: false,
      adminWindowTimer: null,
    };
  },
  computed: {
    dialogTitle() {
      const titleMap = {
        'add': '新建【药库】出库单',
        'edit': `修改 - ${this.rowData?.docNum || ''}`,
        'view': `查看出库单-${this.rowData?.docNum || ''}的详情`,
        'submit': `提交${this.rowData?.docNum || ''}的出库单`,
        'review': `审核${this.rowData?.docNum || ''}的出库单`,
        'pass': `确认过单${this.rowData?.docNum || ''}完成出库`,
        'rollback': `回退${this.rowData?.docNum || ''}的出库单`,
        'fast': `快速调拨${this.rowData?.docNum || ''}`
      };
      return titleMap[this.mode] || '出库单';
    },
    warehouseName() { return '西药'; },
    computedPutinTypeList() {
      return this.putinTypeListLocal.length > 0 ? this.putinTypeListLocal : this.putinTypeList;
    },
    isViewMode() { return this.mode === 'view'; },
    isEditMode() { return this.mode === 'edit'; },
    isSubmitMode() { return this.mode === 'submit'; },
    isReviewMode() { return this.mode === 'review'; },
    isPassMode() { return this.mode === 'pass'; },
    isRollbackMode() { return this.mode === 'rollback'; },
    isFastMode() { return this.mode === 'fast'; },
    isAddMode() { return this.mode === 'add'; },

    isAddButtonDisabled() { return this.drugExistsInSystem; },
    getAddButtonTooltip() {
      if (this.isAddButtonDisabled) return '当前药品已存在于系统目录中无需再次添加！';
      return '';
    },
    canConfirmTraceCodeInput() { return this.validateTraceCodeInputForm(); },
    canConfirmTraceCode() { return this.canConfirmTraceCodeInput; },
    drugExistsInSystem() {
      return this.getSomeWareData && this.getSomeWareData !== '' && (!Array.isArray(this.getSomeWareData) || this.getSomeWareData.length > 0);
    },

    uploadProgress() {
      const totalSteps = this.traceCodeUploadSteps.length;
      return Math.floor((this.traceCodeUploadStep / totalSteps) * 100);
    },
    uploadStatus() {
      if (this.traceCodeHasError) return 'exception';
      return 'success';
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.initData();
          this.loadSuppliers();
          this.loadPutinTypes();
          this.fetchDeptOptions();
          // 加载系统参数（库存审核流程开关）
          this.loadSystemParameters();
        }
      }
    },
    medicineList: {
      handler: function(newVal) { this.calculateSummary(); },
      deep: true
    }
  },
  mounted() { this.loadDrugs(); },
  beforeDestroy() {
    if (this.searchTimer) { clearTimeout(this.searchTimer); this.searchTimer = null; }
    if (this.quantityDebounceTimer) { clearTimeout(this.quantityDebounceTimer); this.quantityDebounceTimer = null; }
    if (this.unbindAdminKeyListener && typeof this.unbindAdminKeyListener === 'function') {
      this.unbindAdminKeyListener();
    }
    this.adminModeWindow = false;
    if (this.adminWindowTimer) { clearTimeout(this.adminWindowTimer); this.adminWindowTimer = null; }
    if (this.progressTimer) { clearInterval(this.progressTimer); this.progressTimer = null; }
    if (this.autoCloseTimer) { clearTimeout(this.autoCloseTimer); this.autoCloseTimer = null; }
    if (this.slowResponseTimer) { clearTimeout(this.slowResponseTimer); this.slowResponseTimer = null; }
    this.addDrugDialogVisible = false;
    this.traceCodeInputDialogVisible = false;
    this.traceCodeDialogVisible = false;
    this.traceCodeSupplementDialogVisible = false;
    this.passProgressDialogVisible = false;
  },
  methods: {
    // ============================================================
    // 加载系统参数：库存审核流程开关
    // value === '0' 时 → inventoryAuditFlowEnabled = false（未启用审核流程，add 模式显示"保存提交"）
    // value === '1' 或其他 → inventoryAuditFlowEnabled = true（启用审核流程，add 模式只显示"确认创建"）
    // ============================================================
    async loadSystemParameters() {
      try {
        this.systemParameterLoading = true;
        const response = await getSystemList();
        if (response && response.code === 200 && response.data) {
          this.systemParameterList = response.data;
          this.findMsfxEntId();
          const auditFlowParam = this.systemParameterList.find(
            p => p.name && p.name.trim() === '库存审核流程开关'
          );
          if (auditFlowParam && auditFlowParam.value !== undefined && auditFlowParam.value !== null) {
            this.inventoryAuditFlowEnabled = String(auditFlowParam.value).trim() !== '0';
          } else {
            this.inventoryAuditFlowEnabled = true;
          }
          console.log('库存审核流程开关:', this.inventoryAuditFlowEnabled);
        } else {
          console.warn('获取系统参数失败，保持默认值');
        }
      } catch (error) {
        console.error('获取系统参数异常:', error);
      } finally {
        this.systemParameterLoading = false;
      }
    },
    findMsfxEntId() {
      if (!this.systemParameterList || this.systemParameterList.length === 0) { this.msfxEntId = ''; return; }
      const msfxParam = this.systemParameterList.find(param => param.name && param.name.trim() === '码上放心entid');
      if (msfxParam && msfxParam.value) this.msfxEntId = msfxParam.value.trim();
      else this.msfxEntId = '';
    },
    async getSystemParameters() {
      try {
        this.systemParameterLoading = true;
        const response = await getSystemList();
        if (response && response.code === 200 && response.data) {
          this.systemParameterList = response.data;
          this.findMsfxEntId();
          return true;
        }
        return false;
      } catch (error) {
        console.error('获取系统参数异常:', error);
        return false;
      } finally {
        this.systemParameterLoading = false;
      }
    },

    // ============================================================
    // 提交前是否需要先上传追溯码
    // - inventoryAuditFlowEnabled = false（value=0，未启用审核流程）→ 提交前需上传追溯码
    // - inventoryAuditFlowEnabled = true（value=1，启用审核流程）→ 直接提交（追溯码在过单时上传）
    // ============================================================
    shouldUploadTraceCodeBeforeSubmit() {
      return !this.inventoryAuditFlowEnabled;
    },

    // ============================================================
    // 工具方法
    // ============================================================
    formatCurrency(value) {
      if (value === null || value === undefined || isNaN(value)) return '0';
      const num = parseFloat(value);
      if (isNaN(num)) return '0';
      const parts = num.toString().split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1] || '';
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (decimalPart) {
        decimalPart = decimalPart.length > 8 ? decimalPart.substring(0, 8) : decimalPart;
        return `${integerPart}.${decimalPart}`;
      } else {
        return integerPart;
      }
    },
    formatDecimal(value, maxDecimals = 8) {
      if (value === null || value === undefined) return '0';
      const num = parseFloat(value);
      if (isNaN(num)) return '0';
      const decimalPlaces = (num.toString().split('.')[1] || '').length;
      const places = Math.min(decimalPlaces, maxDecimals);
      return num.toFixed(places);
    },
    delay(ms) { return new Promise(resolve => setTimeout(resolve, ms)); },
    getDrugTypeText(type) {
      const map = { 1: '西药', 2: '中药', 3: '卫材' };
      return map[type] || '未知';
    },
    getDrugTypeTagType(type) {
      const map = { 1: 'success', 2: 'warning', 3: 'danger' };
      return map[type] || 'info';
    },

    async loadPutinTypes() {
      try {
        const response = await selectOut();
        if (response && response.code === 200 && response.data) {
          this.putinTypeListLocal = response.data;
          this.formData.retnTypeId = 11;
        }
      } catch (error) {
        console.error('加载出库类型失败:', error);
        this.$message.error('加载出库类型失败');
      }
    },
    async fetchDeptOptions() {
      try {
        const clinicId = this.userInfo.clinicId;
        if (clinicId) {
          const res = await findAttribute({ clinicId });
          if (res && res.data) {
            this.deptOptions = res.data.map(obj => ({ ...obj, id: obj.id }));
          }
        }
      } catch (error) {
        console.error('获取科室选项失败:', error);
      }
    },
    async loadSuppliers() {
      this.supplierLoading = true;
      try {
        const response = await selectDropDownList();
        if (response && response.data && response.data.content) {
          this.supplierList = response.data.content;
          this.supplierList.forEach(supplier => {
            if (!supplier.entId) {
              const possibleEntIdFields = ['entId', 'entid', 'ent_id', 'supplierEntId', 'supplierEntid'];
              for (const field of possibleEntIdFields) {
                if (supplier[field]) { supplier.entId = supplier[field]; break; }
              }
              if (!supplier.entId && supplier.id) supplier.entId = supplier.id.toString();
            }
          });
        }
      } catch (error) {
        console.error('加载供货单位失败:', error);
        this.$message.error('加载供货单位失败');
      } finally {
        this.supplierLoading = false;
      }
    },
    async loadDrugs(isLoadMore = false) {
      if (!isLoadMore) { this.drugSearchLoading = true; this.drugPageNum = 1; }
      else { this.loadingMoreDrugs = true; this.drugPageNum++; }
      try {
        const params = { pageNum: this.drugPageNum, pageSize: this.drugPageSize, drugName: this.drugSearchQuery || '' };
        const response = await selectDrug(params);
        if (response && response.code === 200 && response.data) {
          const newDrugs = response.data.content || response.data;
          const mappedDrugs = newDrugs.map(drug => ({
            ...drug,
            id: drug.id || drug.drugId,
            drugType: drug.drugType || 1,
            dosUnt: drug.minUntName || drug.dosUnt || '',
            pacUnt: drug.pacUntName || drug.pacUnt || ''
          }));
          if (isLoadMore) {
            const existingIds = new Set(this.drugOptions.map(d => d.id));
            const uniqueNewDrugs = mappedDrugs.filter(d => !existingIds.has(d.id));
            this.drugOptions = [...this.drugOptions, ...uniqueNewDrugs];
            this.allDrugOptions = [...this.allDrugOptions, ...uniqueNewDrugs];
          } else {
            this.drugOptions = mappedDrugs;
            this.allDrugOptions = [...mappedDrugs];
          }
          this.drugHasMore = newDrugs.length >= this.drugPageSize;
        }
      } catch (error) {
        console.error('加载药品列表失败:', error);
        this.$message.error('加载药品列表失败');
      } finally {
        this.drugSearchLoading = false;
        this.loadingMoreDrugs = false;
      }
    },

    handleSupplierChange(supplierId) {
      if (supplierId) {
        const selectedSupplier = this.supplierList.find(item => item.id === supplierId);
        if (selectedSupplier) {
          this.formData.supplierName = selectedSupplier.supplierName;
          this.formData.entId = selectedSupplier.entId || '';
          this.$message.success(`已选择供应商: ${selectedSupplier.supplierName}`);
        }
      } else {
        this.formData.supplierName = '';
        this.formData.supplierCode = '';
        this.formData.entId = '';
      }
    },
    handleAddSupplier() {
      this.supplierForm = {
        address: "", clinicId: 0, contact: "", contactPhone: "", id: 0,
        payAmt: 0, permitNumber: "", entId: "", receAmt: 0, remark: "",
        status: '1', supplierName: ""
      };
      this.supplierDialogVisible = true;
    },
    async handleSaveSupplier() {
      this.$refs.supplierForm.validate(async (valid) => {
        if (valid) {
          this.supplierSaving = true;
          try {
            const response = await addSupplierEntity(this.supplierForm);
            if (response && response.code === 200) {
              this.$message.success('供应商添加成功');
              this.supplierDialogVisible = false;
              await this.loadSuppliers();
              if (response.data && response.data.id) this.formData.supplierId = response.data.id;
            } else {
              this.$message.error(response.message || '添加供应商失败');
            }
          } catch (error) {
            console.error('添加供应商失败:', error);
            this.$message.error('添加供应商失败');
          } finally {
            this.supplierSaving = false;
          }
        }
      });
    },

    initData() {
      if (this.mode === 'add') {
        this.resetForm();
      } else if (this.rowData) {
        this.fillDataFromRowData();
      }
      this.loadDefaultDrugs();
      if (this.$refs.inboundForm) this.$refs.inboundForm.clearValidate();
    },
    resetForm() {
      this.formData = {
        warehouseId: 1,
        businessDate: new Date().toISOString().split('T')[0],
        invoiceNo: '',
        supplierId: '',
        supplierCode: '',
        retnTypeId: 11,
        deptId: '',
        remark: ''
      };
      this.medicineList = [];
      this.totalOutQuantity = 0;
      this.totalOutCost = 0;
      this.totalOutSale = 0;
      this.allowReselectAll = false;
      this.originalDrugDetails = null;
      this.resetDrugSearch();
    },
    async fillDataFromRowData() {
      if (!this.rowData) return;
      this.originalDrugDetails = this.rowData;
      this.formData = {
        warehouseId: this.rowData.shedId || 1,
        businessDate: this.rowData.invoDate || new Date().toISOString().split('T')[0],
        invoiceNo: this.rowData.purcInvoCodg || '',
        supplierId: this.rowData.supplyCandidateId || '',
        supplierCode: this.rowData.supplyCode || '',
        retnTypeId: this.rowData.retnTypeId || 11,
        deptId: this.rowData.deptId || '',
        remark: this.rowData.remarks || ''
      };
      if (this.mode !== 'add' && this.rowData.list && this.rowData.list.length > 0) {
        await this.ensureDrugsInOptions();
        this.medicineList = [];
        for (const item of this.rowData.list) {
          const newMedicine = await this.createMedicineFromRowData(item);
          if (!newMedicine.drugName || newMedicine.drugName === '') {
            const found = this.drugOptions.find(d => d.id === newMedicine.drugId);
            if (found) newMedicine.drugName = found.drugName;
          }
          this.medicineList.push(newMedicine);
        }
      }
      this.calculateSummary();
    },

    loadDefaultDrugs() {},
    resetDrugSearch() {
      this.drugSearchQuery = '';
      this.drugPageNum = 1;
      this.drugHasMore = true;
    },
    canRemoteSearch(row) { return !!row && this.canSearchDrug(row); },
    canClearDrug(row) {
      if (!row) return false;
      if (this.mode === 'add') return true;
      if (this.mode === 'edit') return true;
      return false;
    },
    canSearchDrug(row) {
      if (this.mode === 'add') return true;
      if (this.mode === 'edit') return true;
      return false;
    },
    canSelectDrug(row) {
      if (this.isEditMode) return true;
      if (this.mode === 'add') return true;
      return false;
    },
    getDrugOptionsForRow(row) {
      if (!row) return [];
      if (this.isViewMode || this.isSubmitMode || this.isReviewMode || this.isPassMode || this.isRollbackMode || this.isFastMode) {
        if (row.drugId) {
          const foundDrug = this.drugOptions.find(drug => String(drug.id) === String(row.drugId) || String(drug.drugId) === String(row.drugId));
          if (foundDrug) return [foundDrug];
          else return [{ id: row.drugId, drugId: row.drugId, drugName: row.drugName || '未知药品', label: row.drugName || row.drugId, drugSpec: row.spec, pacSpec: row.packageSpec }];
        }
        return [];
      }
      let options = [];
      if (this.mode === 'add' || this.mode === 'edit') {
        if (row.drugSearchQuery && row.drugSearchQuery.trim()) options = row.drugSearchResults || [];
        else options = this.drugOptions || [];
      }
      return this.deduplicateById(options);
    },
    getDrugFromOriginalData(row) {
      if (this.rowData && this.rowData.list) {
        const originalItem = this.rowData.list.find(item => item.drugId === row.drugId || item.id === row.id);
        if (originalItem && originalItem.drugName) {
          return [{ id: row.drugId, drugName: originalItem.drugName, label: originalItem.drugName, drugSpec: originalItem.drugSpec, pacSpec: originalItem.pacSpec }];
        }
      }
      return [];
    },
    getDrugDisplayLabel(drug, row) {
      if (drug.drugName) return drug.drugName;
      if (drug.label) return drug.label;
      return '未知药品';
    },
    getHighlightedDrugName(drug, row) {
      const drugName = this.getDrugDisplayLabel(drug, row) || '';
      if (this.currentSearchKeyword && this.currentSearchKeyword.trim()) {
        return this.highlightKeyword(drugName, this.currentSearchKeyword);
      }
      return drugName;
    },
    highlightKeyword(text, keyword) {
      if (!text || !keyword || !keyword.trim()) return text || '';
      const searchText = String(text);
      const searchKeyword = String(keyword).trim();
      if (!searchKeyword) return searchText;
      try {
        const regex = new RegExp(`(${this.escapeRegExp(searchKeyword)})`, 'gi');
        return searchText.replace(regex, '<span class="highlight-keyword">$1</span>');
      } catch (error) {
        return searchText;
      }
    },
    escapeRegExp(string) { return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); },
    showNoSearchResults(row) {
      if (!row) return false;
      if ((this.mode === 'add' || (this.mode === 'edit' && row.isNewRow))) {
        const hasSearchQuery = row.drugSearchQuery && row.drugSearchQuery.trim() || this.drugSearchQuery && this.drugSearchQuery.trim();
        const hasSearchResults = row.drugSearchResults && row.drugSearchResults.length > 0;
        return hasSearchQuery && !hasSearchResults;
      }
      return false;
    },
    canLoadMore(row) {
      if (!row) return false;
      if (!this.drugHasMore || this.drugSearchLoading || this.loadingMoreDrugs) return false;
      if (this.mode === 'add') return true;
      if (this.mode === 'edit') return row.isNewRow;
      return false;
    },
    loadMoreDrugs(row) {
      if (this.canLoadMore(row) && !this.drugSearchLoading && !this.loadingMoreDrugs) {
        this.loadDrugs(true);
      }
    },
    handleDrugSearch(query, row) {
      this.currentSearchKeyword = query || '';
      if (!this.canSearchDrug(row)) return;
      this.drugSearchQuery = query || '';
      if (this.mode === 'add' || this.mode === 'edit') row.drugSearchQuery = query || '';
      if (!query || query.trim() === '') {
        this.currentSearchKeyword = '';
        if (this.mode === 'add' || this.mode === 'edit') row.drugSearchResults = [];
        this.resetDrugSearch();
        this.loadDrugs();
        return;
      }
      this.drugPageNum = 1;
      this.drugHasMore = true;
      this.drugSearchLoading = true;
      if (row.isNewRow || this.mode === 'add') row.drugLoading = true;
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(async () => { await this.performDrugSearch(query, row); }, 300);
    },
    deduplicateById(arr) {
      if (!Array.isArray(arr)) return [];
      const seen = new Set();
      return arr.filter(item => {
        const key = item.id || item.drugId;
        if (key === undefined || key === null) return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    async performDrugSearch(query, row) {
      try {
        const searchParams = { pageNum: this.drugPageNum, pageSize: this.drugPageSize, drugName: query.trim() };
        const response = await selectDrug(searchParams);
        if (response && response.code === 200) {
          const rawDrugs = response.data?.content || response.data || [];
          const mappedDrugs = rawDrugs.map(drug => ({
            ...drug,
            id: drug.drugId || drug.id,
            drugType: drug.drugType || 1,
            dosUnt: drug.minUntName || drug.dosUnt || '',
            pacUnt: drug.pacUntName || drug.pacUnt || ''
          }));
          if (this.mode === 'add' || this.mode === 'edit') row.drugSearchResults = mappedDrugs;
          this.drugHasMore = rawDrugs.length >= this.drugPageSize;
          if (rawDrugs.length === 0) this.$message.info(`未找到 "${query}" 的相关药品`);
        } else {
          this.$message.error(response?.message || '搜索药品失败');
        }
      } catch (error) {
        console.error('执行药品搜索失败:', error);
        this.$message.error('搜索药品失败: ' + (error.message || '网络错误'));
      } finally {
        this.drugSearchLoading = false;
        if (this.mode === 'add' || this.mode === 'edit') row.drugLoading = false;
      }
    },
    updateDrugOptionsAfterSearch(newDrugs) {
      const mappedDrugs = newDrugs.map(drug => ({
        ...drug, id: drug.id || drug.drugId, drugType: drug.drugType || 1
      }));
      if (this.drugPageNum === 1) {
        this.drugOptions = mappedDrugs;
        this.allDrugOptions = [...mappedDrugs];
      } else {
        const existingIds = new Set(this.drugOptions.map(d => d.id));
        const uniqueNewDrugs = mappedDrugs.filter(d => !existingIds.has(d.id));
        this.drugOptions = [...this.drugOptions, ...uniqueNewDrugs];
        this.allDrugOptions = [...this.allDrugOptions, ...uniqueNewDrugs];
      }
      this.drugHasMore = newDrugs.length >= this.drugPageSize;
    },
    handleDrugFocus(row) {
      if (!row) return;
      if ((this.mode === 'add' || (this.mode === 'edit' && row.isNewRow)) && row.drugSearchQuery) {
        if (row.drugSearchQuery && row.drugSearchQuery.trim()) {
          row.drugSearchQuery = '';
          row.drugSearchResults = [];
          this.drugSearchQuery = '';
          this.resetDrugSearch();
          this.loadDrugs();
          this.$message.info('已清空搜索内容，显示全部药品');
        } else {
          if (this.drugOptions.length === 0) this.loadDrugs();
        }
      }
    },
    handleDrugScroll(row) {
      if (this.canLoadMore(row) && !this.drugSearchLoading && !this.loadingMoreDrugs) {
        this.loadMoreDrugs(row);
      }
    },
    handleDrugClear(row) {
      this.resetRowDrugInfo(row);
      if (row.isNewRow || this.mode === 'add') {
        row.drugSearchQuery = '';
        row.drugSearchResults = [];
      }
      this.resetDrugSearch();
      this.loadDrugs();
      this.$message.info('已清空药品选择，可重新选择');
    },
    resetRowDrugInfo(row) {
      row.drugId = '';
      row.drugName = '';
      row.spec = '';
      row.packageSpec = '';
      row.costPricStr = '';
      row.pacCnt = 1;
      row.dosUnt = '';
      row.pacUnt = '';
      row.unitLabel = '';
      row.totalCost = 0;
      row.totalRetail = 0;
      row.manufacturerId = '';
      row.prodentpName = '';
      row.isBar = 0;
      row.drugType = 1;
      row.purcCnt = '';
      row.currentOutCost = '0';
      row.currentOutSale = 0;
      row.purcPric = 0;
      row.salePric = 0;
      row.isFixedPriceText = '';
      row.invId = null;
      if (row.isNewRow || this.mode === 'add') {
        row.drugSearchQuery = '';
        row.drugSearchResults = [];
      }
    },

    async handleDrugChange(row) {
      if (!row.drugId) { this.resetRowDrugInfo(row); return; }
      const targetId = String(row.drugId);
      let selectedDrug = null;
      if (row.drugSearchResults && row.drugSearchResults.length > 0) {
        selectedDrug = row.drugSearchResults.find(item => String(item.id) === targetId || String(item.drugId) === targetId);
      }
      if (!selectedDrug) {
        selectedDrug = this.drugOptions.find(item => String(item.id) === targetId || String(item.drugId) === targetId);
      }
      if (!selectedDrug) {
        selectedDrug = this.allDrugOptions.find(item => String(item.id) === targetId || String(item.drugId) === targetId);
      }
      if (selectedDrug) {
        row.drugId = selectedDrug.drugId || selectedDrug.id;
        row.invId = selectedDrug.invyId || selectedDrug.invId || null;
        row.drugName = selectedDrug.drugName;
        row.drugSpec = selectedDrug.drugSpec || '';
        row.packageSpec = selectedDrug.pacSpec || '';
        row.pacUnt = selectedDrug.pacUnt || '';
        row.isBar = selectedDrug.isBar || 0;
        row.drugType = selectedDrug.drugType || 1;
        row.manufacturerId = selectedDrug.manufacturerId || '';
        row.prodentpName = selectedDrug.prodentpName || '';
        row.dosUnt = selectedDrug.dosUnt || '';
        row.pacUnt = selectedDrug.pacUnt || '';
        this.updateUnitLabel(row);
        if (row.isNewRow) {
          row.manuDate = selectedDrug.manuDate || '';
          row.expyDate = selectedDrug.expyDate || '';
          row.manuLotnum = selectedDrug.manuLotnum || '';
          row.purcCnt = selectedDrug.purcCnt || '';
          row.purcPric = selectedDrug.purcPric || 0;
          row.salePric = selectedDrug.salePric || 0;
          row.isFixedPriceText = (selectedDrug.isFixPrice === 1) ? '已指定' : '未指定';
          row.prodentpNameId = selectedDrug.prodentpNameId || null;
          row.currentOutCost = String(row.purcPric || 0);
          row.currentOutSale = 0;
          row.traceCodes = [];
          row.tracCodeJson = '';
          row.traceCodeButtonText = row.isBar === 1 ? '追溯码' : '追溯码';
        } else {
          if (!row.manuDate) row.manuDate = selectedDrug.manuDate;
          if (!row.expyDate) row.expyDate = selectedDrug.expyDate;
          if (!row.manuLotnum && selectedDrug.manuLotnum !== '1') row.manuLotnum = selectedDrug.manuLotnum;
          if (!row.prodentpName) row.prodentpName = selectedDrug.prodentpName;
        }
        this.calculateRowAmount(row);
      } else {
        this.$message.warning('未找到该药品详细信息，请重新选择');
        this.resetRowDrugInfo(row);
      }
    },

    handleOutCostInput(row, value) {
      if (value === undefined || value === null || value === '') {
        row.currentOutCost = '0';
        this.calculateRowAmount(row);
        return;
      }
      let val = String(value);
      if (val === '.') {
        row.currentOutCost = '.';
        this.calculateRowAmount(row);
        return;
      }
      val = val.replace(/[^0-9.]/g, '');
      const parts = val.split('.');
      if (parts.length > 2) val = parts[0] + '.' + parts.slice(1).join('');
      if (parts.length === 2 && parts[1].length > this.maxDecimalPlaces) {
        val = parts[0] + '.' + parts[1].slice(0, this.maxDecimalPlaces);
      }
      if (val === '' || val === '.') row.currentOutCost = '0';
      else row.currentOutCost = val;
      this.calculateRowAmount(row);
    },

    handleStockTypeChange(row) {
      this.updateUnitLabel(row);
      this.calculateRowAmount(row);
    },
    updateUnitLabel(row) {
      if (row.stockType === 1) row.unitLabel = row.dosUnt || '';
      else if (row.stockType === 2) row.unitLabel = row.pacUnt || '';
      else row.unitLabel = '';
    },

    handleQuantityInput(row, event) {
      if (this.quantityDebounceTimer) {
        clearTimeout(this.quantityDebounceTimer);
        this.quantityDebounceTimer = null;
      }
      const value = event?.target?.value || row.outQuantity;
      if (value === '' || value === null || value === undefined) {
        row.currentOutCost = 0; row.currentOutSale = 0;
        this.calculateRowAmount(row);
        return;
      }
      const qty = parseFloat(value);
      if (isNaN(qty) || qty <= 0) {
        row.currentOutCost = 0; row.currentOutSale = 0;
        this.calculateRowAmount(row);
        return;
      }
      if (!Number.isInteger(qty)) {
        row.currentOutCost = 0; row.currentOutSale = 0;
        this.calculateRowAmount(row);
        return;
      }
      this.calculateRowAmount(row);
      if (row.drugId && row.invId && row.outQuantity) {
        this.quantityDebounceTimer = setTimeout(() => {
          this.autoStockCheck(row);
          this.quantityDebounceTimer = null;
        }, 500);
      }
    },

    async autoStockCheck(row) {
      if (!row.drugId || !row.outQuantity || !row.invId) return;
      if (row.checkingStock) return;
      try {
        row.checkingStock = true;
        const params = { amount: row.outQuantity, invId: row.invId, purcType: row.stockType || 2 };
        const response = await docOutJoin(params);
        if (response && response.code === 200) {
          if (response.data && response.data.length > 0) {
            const first = response.data[0];
            row.purcPric = first.retnPric || row.purcPric;
            row.salePric = first.salePric || row.salePric;
            row.dosUnt = first.minUntName || first.dosUnt || row.dosUnt || '';
            row.pacUnt = first.pacUntName || first.pacUnt || row.pacUnt || '';
            this.updateUnitLabel(row);
            const retnPric = parseFloat(first.retnPric) || 0;
            const apllyAmt = parseFloat(first.apllyAmt) || parseFloat(row.outQuantity) || 0;
            row.currentOutCost = retnPric * apllyAmt;
            const salePric = parseFloat(first.salePric) || 0;
            row.currentOutSale = salePric * apllyAmt;
            row.prodentpName = first.prodentpName || row.prodentpName;
            if (first.manuLotnum && first.manuLotnum !== '1') row.manuLotnum = first.manuLotnum;
            row.manuDate = first.manuDate || row.manuDate;
            row.expyDate = first.expyDate || row.expyDate;
            row.purcCnt = first.purcCnt || row.purcCnt;
          }
          if (this.mode === 'add' || this.mode === 'edit') {
            row.isLocked = true;
            row.isEditing = false;
            row.verified = true;
          }
          this.$message.success(`${row.drugName} 库存验证成功`);
        } else {
          const errorMsg = response?.message || '库存验证失败，请检查出库数量是否超过库存';
          this.$alert(errorMsg, '系统提示', { confirmButtonText: '确定', type: 'error', center: true, customClass: 'system-alert-dialog' });
        }
      } catch (error) {
        console.error('库存验证失败:', error);
        this.$alert(error.message || '库存验证失败，请检查网络连接', '系统提示', { confirmButtonText: '确定', type: 'error', center: true, customClass: 'system-alert-dialog' });
      } finally {
        row.checkingStock = false;
      }
    },

    handleAddMedicine() {
      this.medicineList = this.medicineList.filter(item => item !== null);
      if (this.medicineList.length > 0) {
        const lastRowValid = this.medicineList[this.medicineList.length - 1];
        if (!lastRowValid) { this.pushNewMedicine(); return; }
        if (!lastRowValid.drugId || !lastRowValid.outQuantity) {
          this.$message.warning('请先完成当前行的药品选择和出库数量');
          return;
        }
        if (!lastRowValid.isLocked) {
          this.$message.warning('请先完成当前行的库存验证');
          return;
        }
        if (lastRowValid.isBar === 1 && (!lastRowValid.traceCodes || lastRowValid.traceCodes.length === 0)) {
          this.$message.warning(`请先为「${lastRowValid.drugName}」录入追溯码`);
          return;
        }
      }
      this.pushNewMedicine();
    },
    pushNewMedicine() {
      if (this.allDrugOptions && this.allDrugOptions.length > 0) this.drugOptions = [...this.allDrugOptions];
      else this.loadDrugs();
      this.drugSearchQuery = '';
      const newMedicine = {
        id: '', drugId: '', drugName: '', outQuantity: '', stockType: 2, pacCnt: 1,
        purcCnt: '', manuLotnum: '', manuDate: '', expyDate: '', prodentpName: '', prodentpNameId: '',
        purcPric: 0, salePric: 0, currentOutCost: '0', currentOutSale: 0, drugSpec: '',
        dosUnt: '', pacUnt: '', unitLabel: '', isBar: 0, isNewRow: this.isEditMode,
        drugSearchQuery: '', drugSearchResults: [], drugLoading: false, drugType: 1,
        traceCodes: [], tracCodeJson: '', traceCodeButtonText: '追溯码',
        invId: null, isLocked: false, isEditing: this.isEditMode, verified: false, checkingStock: false,
        isFixedPriceText: '未指定', markUpId: 1, isFixPrice: 0, markUpRatio: 0, markUpAmount: 0
      };
      this.medicineList.push(newMedicine);
      if (this.drugOptions.length === 0) this.loadDrugs();
    },
    handleRemoveMedicine(index, row) {
      if (this.isEditMode && row.isNewRow && !row.drugId) {
        this.medicineList.splice(index, 1);
        this.$message.success('已移除');
        return;
      }
      const confirmMessage = row.drugName ? `您目前已选择了（${row.drugName}），请确认是否继续移除？` : '确定移除该药品吗?';
      this.$confirm(confirmMessage, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => { this.medicineList.splice(index, 1); this.$message.success('移除成功'); }).catch(() => {});
    },
    calculateRowAmount(row) {
      const qty = parseFloat(row.outQuantity) || 0;
      const cost = parseFloat(row.currentOutCost) || 0;
      row.currentOutSale = cost * qty;
      row.totalCost = cost * qty;
      row.totalRetail = row.totalCost;
    },
    calculateSummary() {
      this.totalOutQuantity = this.medicineList.reduce((sum, item) => sum + (parseFloat(item.outQuantity) || 0), 0);
      this.totalOutCost = this.medicineList.reduce((sum, item) => sum + (parseFloat(item.currentOutCost) || 0), 0);
      this.totalOutSale = this.medicineList.reduce((sum, item) => sum + (parseFloat(item.currentOutSale) || 0), 0);
    },

    async createMedicineFromRowData(item) {
      const cost = item.retnPric || 0;
      const qty = item.retnCnt || 1;
      let drugName = item.drugName || '';
      if (!drugName) {
        const found = this.drugOptions.find(d => d.id === item.drugId);
        if (found) drugName = found.drugName;
      }
      let traceCodes = [];
      let tracCodeJson = item.tracCodeJson || '';
      if (tracCodeJson && typeof tracCodeJson === 'string') {
        try {
          const parsed = JSON.parse(tracCodeJson);
          if (Array.isArray(parsed)) traceCodes = parsed;
          else if (parsed && typeof parsed === 'object') traceCodes = parsed.traceCodes || [];
        } catch (e) { console.warn('解析 tracCodeJson 失败:', e); }
      } else if (Array.isArray(tracCodeJson)) {
        traceCodes = tracCodeJson;
      }
      if (traceCodes.length === 0 && item.traceCodes && item.traceCodes.length > 0) traceCodes = item.traceCodes;
      const dosUnt = item.minUntName || item.dosUnt || '';
      const pacUnt = item.pacUntName || item.pacUnt || '';
      const purcType = item.purcType || 2;
      const unitLabel = purcType === 1 ? dosUnt : pacUnt;
      const newMedicine = {
        id: item.id, drugId: item.drugId || '', drugName: drugName,
        outQuantity: qty, stockType: item.purcType || 2, pacCnt: item.pacCnt || 1,
        purcCnt: item.purcCnt || '', manuLotnum: item.manuLotnum || '',
        manuDate: item.manuDate || '', expyDate: item.expyDate || '',
        prodentpName: item.prodentpName || '', prodentpNameId: item.prodentpNameId || '',
        purcPric: cost, salePric: item.salePric || 0,
        currentOutCost: String(item.retnAmt || 0), currentOutSale: item.saleAmt || 0,
        drugSpec: item.drugSpec || '', dosUnt: dosUnt || '', pacUnt: pacUnt || '', unitLabel: unitLabel,
        isNewRow: false, drugType: item.drugType || 1, isBar: item.isBar || 0,
        traceCodes: traceCodes, tracCodeJson: tracCodeJson,
        traceCodeButtonText: (item.isBar === 1 && traceCodes.length > 0) ? `追溯码(${traceCodes.length})` : '追溯码',
        invId: item.invId || null, isLocked: true, isEditing: false, verified: true,
        isFixedPriceText: (item.isFixPrice === 1) ? '已指定' : '未指定',
        markUpId: item.markUpId || 1, isFixPrice: item.isFixPrice || 0, markUpRatio: 0, markUpAmount: 0
      };
      await this.ensureDrugDetailsForRow(newMedicine);
      return newMedicine;
    },
    async ensureDrugDetailsForRow(medicine) {
      if (medicine.drugName && medicine.drugName.trim() !== '') return;
      if (medicine.drugId) {
        const foundDrug = this.drugOptions.find(drug => drug.id === medicine.drugId);
        if (foundDrug && foundDrug.drugName) {
          medicine.drugName = foundDrug.drugName;
          medicine.drugSpec = foundDrug.drugSpec || medicine.drugSpec;
          medicine.dosUnt = foundDrug.dosUnt || '';
          medicine.pacUnt = foundDrug.pacUnt || '';
          medicine.prodentpName = foundDrug.prodentpName || '';
          medicine.isBar = foundDrug.isBar || 0;
        }
        if (this.originalDrugDetails && this.originalDrugDetails.list) {
          const orig = this.originalDrugDetails.list.find(item => item.drugId === medicine.drugId);
          if (orig) {
            medicine.drugName = orig.drugName || orig.name || '';
            medicine.drugSpec = orig.drugSpec || '';
            medicine.prodentpName = orig.prodentpName || '';
          }
        }
      }
    },
    async ensureDrugsInOptions() {
      if (!this.rowData || !this.rowData.list) return;
      const drugIds = this.rowData.list.filter(item => item.drugId).map(item => item.drugId);
      for (const drugId of drugIds) {
        if (!this.drugOptions.some(d => d.id === drugId)) {
          const found = this.allDrugOptions.find(d => d.id === drugId);
          if (!found) {
            const item = this.rowData.list.find(i => i.drugId === drugId);
            if (item) {
              this.drugOptions.push({
                id: drugId, drugId: drugId, drugName: item.drugName || item.name || '未知',
                drugSpec: item.drugSpec || '', pacSpec: item.pacSpec || '',
                prodentpName: item.prodentpName || '', drugType: item.drugType || 1,
                isBar: item.isBar || 0, pacCnt: item.pacCnt || 1,
                dosUnt: item.dosUnt || '', pacUnt: item.pacUnt || '',
                purcCnt: item.purcCnt || '', purcPric: item.retnPric || 0,
                salePric: item.salePric || 0, invyId: item.invId || null,
                prodentpNameId: item.prodentpNameId || null
              });
            }
          }
        }
      }
    },

    canTraceCode(row) {
      if (this.mode === 'add') {
        if (!row.drugId) return false;
        if (row.isBar !== 1) return false;
        return true;
      }
      if (this.mode === 'edit') {
        if (row.isNewRow) return !!(row.drugId && row.isBar === 1);
        return this.rowData && this.rowData.state === 0;
      }
      return false;
    },
    getTraceCodeTooltip(row) {
      if (this.mode === 'add') {
        if (!row.drugId) return '要上传追溯码，请先选择对应的药品信息';
        if (row.isBar === 0) return '当前药品未启用追溯码功能';
        return '';
      }
      if (this.mode === 'edit') {
        if (row.isNewRow) {
          if (!row.drugId) return '请先选择药品';
          if (row.isBar !== 1) return '当前药品未启用追溯码功能';
          return '';
        }
        if (!this.rowData || this.rowData.state !== 0) return '只有草稿状态的单据才能上传追溯码';
        return '';
      }
      return '';
    },
    openTraceCodeSupplement(row) {
      this.currentTraceMedicine = row;
      this.traceCodeSupplementList = [];
      const packageCount = parseInt(row.pacCnt) || 1;
      const drugName = row.drugName || '';
      const drugSpec = row.drugSpec || '';
      const manufacturer = row.prodentpName || '';
      const batchNo = row.manuLotnum || '';
      const produceDate = row.manuDate || '';
      const expireDate = row.expyDate || '';
      let traceList = [];
      if (row.tracCodeJson && typeof row.tracCodeJson === 'string') {
        try {
          const parsed = JSON.parse(row.tracCodeJson);
          if (Array.isArray(parsed)) traceList = parsed;
          else if (parsed && typeof parsed === 'object' && Array.isArray(parsed.traceCodes)) traceList = parsed.traceCodes;
          else if (parsed && typeof parsed === 'object' && Array.isArray(parsed.list)) traceList = parsed.list;
        } catch (e) { console.warn('解析 tracCodeJson 失败:', e, row.tracCodeJson); }
      } else if (Array.isArray(row.tracCodeJson)) {
        traceList = row.tracCodeJson;
      }
      if (traceList.length === 0 && row.traceCodes && row.traceCodes.length > 0) traceList = row.traceCodes;
      if (traceList && traceList.length > 0) {
        traceList.forEach((trace, index) => {
          const code = trace.barcode || trace.traceCode || trace.code || '';
          const qty = trace.chgCnt || trace.availableQty || trace.qty || packageCount;
          this.traceCodeSupplementList.push({
            id: Date.now() + index, traceCode: code,
            drugName: trace.drugName || drugName, spec: trace.spec || drugSpec,
            packageSpec: row.packageSpec || '', availableQty: parseInt(qty) || packageCount,
            manufacturer: trace.manufacturer || manufacturer,
            batchNo: trace.batchNo || batchNo, produceDate: trace.produceDate || produceDate,
            expireDate: trace.expireDate || expireDate, isEditing: false
          });
        });
      } else {
        this.traceCodeSupplementList.push({
          id: Date.now(), traceCode: '', drugName: drugName, spec: drugSpec,
          packageSpec: row.packageSpec || '', availableQty: packageCount,
          manufacturer: manufacturer, batchNo: batchNo,
          produceDate: produceDate, expireDate: expireDate, isEditing: true
        });
      }
      this.traceCodeSupplementDialogVisible = true;
    },
    handleCancelTraceCodeSupplement() {
      this.traceCodeSupplementDialogVisible = false;
      this.traceCodeSupplementList = [];
    },
    handleAddSupplementTraceCode() {
      if (!this.currentTraceMedicine) { this.$message.warning('未找到当前药品信息！'); return; }
      const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
      this.traceCodeSupplementList.push({
        id: Date.now() + Math.random(), traceCode: '',
        drugName: this.currentTraceMedicine.drugName || '',
        spec: this.currentTraceMedicine.drugSpec || '',
        availableQty: packageCount,
        manufacturer: this.currentTraceMedicine.prodentpName || '',
        batchNo: this.currentTraceMedicine.manuLotnum || '',
        produceDate: this.currentTraceMedicine.manuDate || '',
        expireDate: this.currentTraceMedicine.expyDate || '',
        isEditing: true
      });
      this.$message.success('已添加新的追溯码行，请填写追溯码');
    },
    handleEditSupplementRow(index) { this.traceCodeSupplementList[index].isEditing = true; },
    handleCancelSupplementEdit(index) {
      if (this.traceCodeSupplementList[index].isFirstRow) return;
      if (!this.traceCodeSupplementList[index].traceCode || this.traceCodeSupplementList[index].traceCode.trim() === '') {
        this.traceCodeSupplementList.splice(index, 1);
      } else {
        this.traceCodeSupplementList[index].isEditing = false;
      }
    },
    handleSaveSupplementRow(index) {
      const row = this.traceCodeSupplementList[index];
      if (!row.traceCode || row.traceCode.trim() === '') { this.$message.warning('请输入追溯码'); return; }
      if (/[\u4e00-\u9fa5]/.test(row.traceCode)) { this.$message.warning('追溯码不能包含中文'); return; }
      const traceCodes = this.traceCodeSupplementList.map(item => item.traceCode.trim());
      const duplicateIndex = traceCodes.findIndex((code, idx) => idx !== index && code === row.traceCode.trim() && code !== '');
      if (duplicateIndex !== -1) { this.$message.warning('追溯码不能重复'); return; }
      row.isEditing = false;
      this.$message.success('保存成功');
    },
    handleRemoveSupplementRow(index) {
      if (this.traceCodeSupplementList[index].isFirstRow && this.traceCodeSupplementList.length === 1) {
        this.traceCodeSupplementDialogVisible = false;
      } else {
        this.traceCodeSupplementList.splice(index, 1);
      }
    },
    handleConfirmTraceCodeSupplement() {
      if (this.traceCodeSupplementList.length === 0) { this.$message.warning('请至少录入一个追溯码'); return; }
      const emptyTraceCode = this.traceCodeSupplementList.find(row => !row.traceCode || row.traceCode.trim() === '');
      if (emptyTraceCode) { this.$message.warning('请填写所有追溯码'); return; }
      const traceCodes = this.traceCodeSupplementList.map(row => row.traceCode.trim());
      const duplicateSet = new Set();
      const duplicates = [];
      traceCodes.forEach((code) => {
        if (duplicateSet.has(code) && code !== '') duplicates.push(code);
        else duplicateSet.add(code);
      });
      if (duplicates.length > 0) { this.$message.warning(`追溯码不能重复: ${duplicates.join(', ')}`); return; }
      if (this.currentTraceMedicine) {
        const purcType = parseInt(this.currentTraceMedicine.stockType) || 2;
        const packageCount = parseInt(this.currentTraceMedicine.pacCnt) || 1;
        const traceCodesArr = this.traceCodeSupplementList.map(row => ({
          traceCode: row.traceCode, drugName: row.drugName, spec: row.spec,
          packageSpec: row.packageSpec, manufacturer: row.manufacturer,
          batchNo: row.batchNo, produceDate: row.produceDate, expireDate: row.expireDate,
          availableQty: parseInt(row.availableQty) || 1
        }));
        const tracCodeJson = traceCodesArr.map(item => ({
          barcode: item.traceCode,
          chgCnt: purcType === 2 ? packageCount : item.availableQty,
          manuLotnum: item.batchNo || ''
        }));
        this.currentTraceMedicine.traceCodes = traceCodesArr;
        this.currentTraceMedicine.tracCodeJson = JSON.stringify(tracCodeJson);
        this.currentTraceMedicine.traceCodeButtonText = `追溯码(${traceCodesArr.length})`;
        this.$message.success('追溯码补录成功');
        this.traceCodeSupplementDialogVisible = false;
        this.traceCodeSupplementList = [];
      }
    },
    handleTraceCodeDialogClose(done) {
      if (this.traceCodeList.length > 0) {
        this.$confirm('确定关闭追溯码录入吗？未保存的数据将丢失', '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
        }).then(() => { this.resetTraceCodeDialog(); done(); }).catch(() => {});
      } else { this.resetTraceCodeDialog(); done(); }
    },
    handleCancelTraceCode() { this.traceCodeDialogVisible = false; this.resetTraceCodeDialog(); },
    resetTraceCodeDialog() {
      this.traceCodeDialogVisible = false;
      this.currentTraceMedicine = null;
      this.traceCodeList = [];
      this.totalTraceQty = 0;
      this.scanInput = '';
    },
    handleConfirmTraceCode() {
      const invalidCodes = this.traceCodeList.filter(item => !item.traceCode || item.traceCode.trim() === '');
      if (invalidCodes.length > 0) { this.$message.warning(`有${invalidCodes.length}条追溯码为空，请填写完整`); return; }
      const outQty = this.currentTraceMedicine ? parseInt(this.currentTraceMedicine.outQuantity) : 0;
      if (this.totalTraceQty !== outQty) { this.$message.warning(`追溯码总数量（${this.totalTraceQty}）必须等于出库数量（${outQty}）`); return; }
      if (this.currentTraceMedicine) {
        this.currentTraceMedicine.traceCodes = this.traceCodeList.map(item => ({
          code: item.traceCode, availableQty: item.availableQty, remark: item.remark,
          status: item.status, batchNo: item.batchNo, approvalLicenceNo: item.approvalLicenceNo,
          produceDate: item.produceDate, expireDate: item.expireDate,
          originalProduceDate: item.originalProduceDate, pkgAmount: item.pkgAmount,
          physicTypeDesc: item.physicTypeDesc, prepnTypeDesc: item.prepnTypeDesc,
          codeStatus: item.codeStatus, packageLevel: item.packageLevel,
          manufacturer: item.manufacturer, drugName: item.drugName, spec: item.spec
        }));
        this.currentTraceMedicine.tracCodeJson = JSON.stringify({
          drugId: this.currentTraceMedicine.drugId,
          drugName: this.currentTraceMedicine.drugName,
          traceCodes: this.currentTraceMedicine.traceCodes
        });
        this.currentTraceMedicine.traceCodeButtonText = `追溯码(${this.traceCodeList.length})`;
        this.$message.success(`已保存${this.traceCodeList.length}条追溯码`);
        this.traceCodeDialogVisible = false;
        this.resetTraceCodeDialog();
      }
    },
    async handleScanInput() {
      if (!this.scanInput || this.scanInput.trim() === '') { this.$message.warning('请输入追溯码'); return; }
      const traceCode = this.scanInput.trim();
      if (this.traceCodeList.some(item => item.traceCode === traceCode)) {
        this.$message.warning('该追溯码已存在');
        this.scanInput = '';
        return;
      }
      try {
        this.traceCodeLoading = true;
        const response = await msfxCodeDetail({ codes: traceCode });
        if (response && response.code === 200 && response.data && response.data.length > 0) {
          const traceCodeData = response.data[0];
          const drugInfo = traceCodeData.drugEntBaseDTO || {};
          const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
          const entInfo = traceCodeData.pUserEntDTO || {};
          const codeStatus = traceCodeData.codeStatusTypeDTO || {};
          const outQty = this.currentTraceMedicine ? parseInt(this.currentTraceMedicine.outQuantity) : 0;
          const currentTotal = this.totalTraceQty;
          if (currentTotal >= outQty) {
            this.$message.warning(`追溯码总数量（${currentTotal}）已达到出库数量（${outQty}），无法添加更多`);
            this.scanInput = '';
            return;
          }
          const pacCnt = parseInt(produceInfo.pkgAmount) || 1;
          const remainingQty = outQty - currentTotal;
          const defaultQty = Math.min(pacCnt, remainingQty);
          let remark = '';
          if (produceInfo.produceDateStr) remark += `生产日期: ${produceInfo.produceDateStr}`;
          if (produceInfo.originalExpireDate) remark += (remark ? ', ' : '') + `有效期: ${produceInfo.originalExpireDate}`;
          if (drugInfo.approvalLicenceNo) remark += (remark ? ', ' : '') + `批准文号: ${drugInfo.approvalLicenceNo}`;
          if (codeStatus.codeStatus) remark += (remark ? ', ' : '') + `码状态: ${codeStatus.codeStatus}`;
          this.traceCodeList.push({
            id: this.traceCodeList.length + 1, traceCode: traceCode,
            drugName: drugInfo.physicName || this.currentTraceMedicine?.drugName || '',
            spec: drugInfo.prepnSpec || drugInfo.pkgSpecCrit || this.currentTraceMedicine?.drugSpec || '',
            availableQty: defaultQty,
            manufacturer: entInfo.entName || this.currentTraceMedicine?.prodentpName || '',
            remark: remark, status: 'active',
            batchNo: produceInfo.batchNo || '', approvalLicenceNo: drugInfo.approvalLicenceNo || '',
            produceDate: produceInfo.produceDateStr || '', expireDate: produceInfo.originalExpireDate || '',
            originalProduceDate: produceInfo.originalProduceDate || '', pkgAmount: produceInfo.pkgAmount || '',
            physicTypeDesc: drugInfo.physicTypeDesc || '', prepnTypeDesc: drugInfo.prepnTypeDesc || '',
            codeStatus: codeStatus.codeStatus || '', packageLevel: traceCodeData.packageLevel || ''
          });
          this.$message.success(`追溯码添加成功，数量：${defaultQty}`);
          this.scanInput = '';
          this.calculateTotalTraceQty();
        } else {
          this.$message.error(response?.message || '未找到追溯码信息');
        }
      } catch (error) {
        console.error('获取追溯码详情失败:', error);
        this.$message.error('获取追溯码详情失败');
      } finally {
        this.traceCodeLoading = false;
      }
    },
    calculateTotalTraceQty() {
      this.totalTraceQty = this.traceCodeList.reduce((sum, item) => sum + (parseInt(item.availableQty) || 1), 0);
      return this.totalTraceQty;
    },
    async handleOuterScanConfirm() {
      if (!this.outerScanInput || this.outerScanInput.trim() === '') {
        this.$message.warning('请输入追溯码');
        return;
      }
      const traceCode = this.outerScanInput.trim();

      const loadingInstance = this.$loading({
        lock: true,
        text: '正在进行追溯码查询...',
        background: 'rgba(0,0,0,0.7)'
      });

      let cancelled = false;
      let isClosed = false;
      let slowNotifyInstance = null;
      let slowTimer = null;

      slowTimer = setTimeout(() => {
        if (!isClosed && !cancelled) {
          if (loadingInstance) {
            loadingInstance.close();
            isClosed = true;
          }
          this.outerScanLoading = false;

          slowNotifyInstance = this.$notify({
            title: '提示',
            message: '响应过慢，请点击此处重试',
            type: 'warning',
            duration: 0,
            onClick: () => {
              cancelled = true;
              if (slowNotifyInstance) {
                slowNotifyInstance.close();
                slowNotifyInstance = null;
              }
            }
          });
        }
      }, 5000);

      try {
        this.outerScanLoading = true;
        this.outerScanInput = '';

        const response = await msfxCodeDetail({ codes: traceCode });

        if (slowTimer) { clearTimeout(slowTimer); slowTimer = null; }

        if (cancelled) {
          if (slowNotifyInstance) {
            slowNotifyInstance.close();
            slowNotifyInstance = null;
          }
          return;
        }

        if (!isClosed && loadingInstance) {
          loadingInstance.close();
          isClosed = true;
        }
        if (slowNotifyInstance) {
          slowNotifyInstance.close();
          slowNotifyInstance = null;
        }

        const isSuccess = response && (response.code == 200 || response.code === '200');
        if (isSuccess && response.data && response.data.length > 0) {
          const traceCodeData = response.data[0];
          const drugInfo = traceCodeData.drugEntBaseDTO || {};
          const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
          const entInfo = traceCodeData.pUserEntDTO || {};
          const drugName = drugInfo.physicName || '';
          const spec = drugInfo.pkgSpecCrit || '';
          const manufacturer = entInfo.entName || '';
          const manufacturerId = entInfo.refEntId || '';
          const approvalLicenceNo = drugInfo.approvalLicenceNo || '';
          const batchNo = produceInfo.batchNo || '';
          const expireDate = produceInfo.originalExpireDate || '';
          const produceDate = produceInfo.produceDateStr || '';
          const prepnSpec = drugInfo.prepnSpec || '1';
          const pacCnt = this.extractNumberFromString(prepnSpec) || 1;
          this.traceCodeInputForm.drugName = drugName;
          this.traceCodeInputForm.spec = spec;
          this.traceCodeInputForm.pacCnt = pacCnt;
          this.traceCodeInputForm.dosageFormName = drugInfo.prepnTypeDesc || '';
          this.traceCodeInputForm.manufacturer = manufacturer;
          this.traceCodeInputForm.manufacturerId = manufacturerId;
          this.traceCodeInputForm.approvalLicenceNo = approvalLicenceNo;
          this.traceCodeInputForm.manuLotnum = batchNo;
          this.traceCodeInputForm.expireDate = expireDate;
          this.traceCodeInputForm.produceDate = produceDate;
          this.traceCodeInputForm.purcType = 2;
          this.traceCodeInputForm.inboundQty = 1;
          this.traceCodeInputForm.unitLabel = '包装单位';
          this.traceCodeInputForm.traceCode = traceCode;
          this.traceCodeDetailData = traceCodeData;

          this.traceCodeInputDialogVisible = true;
          this.$message.success('追溯码信息获取成功');
          if (drugName && pacCnt) {
            await this.callGetSomeWare(drugName, manufacturer, pacCnt, approvalLicenceNo);
          }
        } else {
          this.$message.error(response?.message || '未找到追溯码信息或接口返回异常');
        }
      } catch (error) {
        if (slowTimer) { clearTimeout(slowTimer); slowTimer = null; }
        if (!isClosed && loadingInstance) {
          loadingInstance.close();
          isClosed = true;
        }
        if (slowNotifyInstance) {
          slowNotifyInstance.close();
          slowNotifyInstance = null;
        }
        if (cancelled) return;
        console.error('获取追溯码详情失败:', error);
        this.$message.error('获取追溯码详情失败，请检查追溯码是否正确');
      } finally {
        this.outerScanLoading = false;
      }
    },
    async callGetSomeWare(drugName, manufacturer, pacCnt, approvalLicenceNo) {
      if (!drugName || !pacCnt || !approvalLicenceNo) return;
      try {
        this.getSomeWareLoading = true;
        const response = await getSomeWare({ manufacturerName: manufacturer, pacCnt: pacCnt, approvalNumber: approvalLicenceNo });
        if (response && response.code === 200) {
          if (response.data && response.data !== '' && (!Array.isArray(response.data) || response.data.length > 0)) {
            this.getSomeWareData = response.data;
            this.showBottomAddButton = false;
            this.traceCodeInputForm.pacUnt = response.data.pacUnt || '包装单位';
            this.traceCodeInputForm.dosUnt = response.data.dosUnt || '最小单位';
            if (response.data.manufacturerId) this.traceCodeInputForm.manufacturerId = response.data.manufacturerId;
            this.updateUnitLabelForm(this.traceCodeInputForm);
          } else {
            this.handleEmptyDrugResponse(drugName);
          }
        } else {
          this.$message.warning(response?.message || '未找到相关药品信息');
          this.handleEmptyDrugResponse(drugName);
        }
      } catch (error) {
        console.error('调用getSomeWare接口失败:', error);
        this.handleEmptyDrugResponse(drugName);
      } finally {
        this.getSomeWareLoading = false;
      }
    },
    handleEmptyDrugResponse(drugName) {
      this.$confirm(
        `${drugName}该药品未存在于本系统目录中，请先去添加该药品基本信息档案！`, '提示',
        { confirmButtonText: '去添加', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(() => {
        this.traceCodeInputList = [];
        this.$nextTick(() => { this.openAddDrugDialog(drugName); });
      }).catch(() => { this.showBottomAddButton = true; });
    },
    handleCloseTraceCodeInput() { this.traceCodeInputDialogVisible = false; this.resetTraceCodeInputForm(); },
    handleCancelTraceCodeInput() { this.handleCloseTraceCodeInput(); },
    resetTraceCodeInputForm() {
      this.traceCodeInputForm = {
        traceCode: '', drugName: '', spec: '', inboundQty: 1, purcType: 2, pacCnt: 1,
        manuLotnum: '', manufacturer: '', manufacturerId: '', approvalLicenceNo: '',
        produceDate: '', expireDate: '', refEntId: '', remark: '', dosageFormName: '', pacUnt: '', dosUnt: ''
      };
      this.traceCodeDetailData = null;
      this.getSomeWareData = null;
      this.showBottomAddButton = false;
    },
    validateTraceCodeInputForm() {
      const requiredFields = ['drugName', 'pacCnt', 'inboundQty', 'manufacturer', 'approvalLicenceNo'];
      for (const field of requiredFields) {
        if (!this.traceCodeInputForm[field] || this.traceCodeInputForm[field] === '') return false;
      }
      return true;
    },
    validateTraceCodeCount() {
      if (!this.traceCodeInputList || this.traceCodeInputList.length === 0) return true;
      const traceCodeCounts = {};
      this.traceCodeInputList.forEach(item => {
        if (item.traceCode) {
          const code = item.traceCode.trim();
          if (code) traceCodeCounts[code] = (traceCodeCounts[code] || 0) + 1;
        }
      });
      for (const [traceCode, count] of Object.entries(traceCodeCounts)) {
        if (count > this.traceCodeInputForm.pacCnt) return false;
      }
      return true;
    },
    checkIfTraceCodeAlreadyAdded(traceCode) {
      for (const medicine of this.medicineList) {
        if (medicine.traceCodes && medicine.traceCodes.length > 0) {
          if (medicine.traceCodes.some(item => item.traceCode === traceCode)) return true;
        }
      }
      return false;
    },
    extractNumberFromString(str) {
      if (str === null || str === undefined || str === '') return 1;
      const matches = String(str).match(/(\d+(\.\d+)?)/);
      if (matches && matches[1]) {
        const result = parseFloat(matches[1]);
        if (isNaN(result) || result <= 0) return 1;
        return result;
      }
      return 1;
    },
    openAddDrugDialog(drugName) {
      if (drugName && typeof drugName === 'object' && drugName.target) drugName = this.traceCodeInputForm.drugName || '';
      if (!drugName) drugName = this.traceCodeInputForm.drugName || '';
      const traceData = this.traceCodeDetailData;
      let drugId = ''; let prepnTypeDesc = '';
      if (traceData && traceData.drugEntBaseDTO) {
        drugId = traceData.drugEntBaseDTO.id || '';
        prepnTypeDesc = traceData.drugEntBaseDTO.prepnTypeDesc || '';
      }
      this.addDrugDialogData = {
        drugName, spec: this.traceCodeInputForm.spec || '',
        pacCnt: this.traceCodeInputForm.pacCnt || 1,
        approvalLicenceNo: this.traceCodeInputForm.approvalLicenceNo || '',
        manufacturer: this.traceCodeInputForm.manufacturer || '',
        manufacturerId: this.traceCodeInputForm.manufacturerId || '',
        remark: this.traceCodeInputForm.remark || '',
        isBar: 1, drugId, prepnTypeDesc
      };
      this.addDrugDialogVisible = true;
      this.showBottomAddButton = false;
    },
    handleAddDrugSuccess(addedDrugData) {
      this.$message.success('药品目录添加成功');
      this.traceCodeInputForm.drugName = addedDrugData.drugName || this.traceCodeInputForm.drugName;
      this.traceCodeInputForm.spec = addedDrugData.spec || this.traceCodeInputForm.spec;
      this.traceCodeInputForm.pacCnt = addedDrugData.pacCnt || this.traceCodeInputForm.pacCnt;
      this.traceCodeInputForm.approvalLicenceNo = addedDrugData.approvalLicenceNo || this.traceCodeInputForm.approvalLicenceNo;
      this.traceCodeInputForm.manufacturer = addedDrugData.prodentpName || '';
      this.traceCodeInputForm.manufacturerId = addedDrugData.manufacturerId || '';
      if (addedDrugData.dosageFormName) {
        if (this.traceCodeDetailData && this.traceCodeDetailData.drugEntBaseDTO) {
          this.traceCodeDetailData.drugEntBaseDTO.prepnTypeDesc = addedDrugData.dosageFormName;
        }
        this.traceCodeInputForm.dosageFormName = addedDrugData.dosageFormName;
      }
      if (this.traceCodeInputForm.drugName && this.traceCodeInputForm.pacCnt) {
        this.callGetSomeWare(this.traceCodeInputForm.drugName, this.traceCodeInputForm.pacCnt);
      }
      this.addDrugDialogVisible = false;
      this.showBottomAddButton = false;
    },

    async performDrugMatch() {
      const drugName = this.traceCodeInputForm.drugName;
      let getSomeWareData = this.getSomeWareData;
      if (Array.isArray(getSomeWareData) && getSomeWareData.length > 0) getSomeWareData = getSomeWareData[0];
      if (!drugName || !getSomeWareData) return null;
      try {
        const params = { pageNum: 1, pageSize: 100, drugName: drugName };
        const response = await selectDrug(params);
        if (response && response.code === 200) {
          const rawDrugs = response.data?.content || response.data || [];
          const mappedDrugs = rawDrugs.map(drug => ({
            ...drug, id: drug.drugId || drug.id, drugType: drug.drugType || 1
          }));
          const targetDrugId = getSomeWareData.id || getSomeWareData.drugId;
          const targetPacCnt = getSomeWareData.pacCnt;
          const targetManufacturerId = getSomeWareData.manufacturerId;
          for (const drug of mappedDrugs) {
            const drugIdMatch = String(drug.drugId || drug.id) === String(targetDrugId);
            const pacCntMatch = Number(drug.pacCnt) === Number(targetPacCnt);
            const manufacturerIdMatch = String(drug.prodentpNameId || '') === String(targetManufacturerId || '');
            if (drugIdMatch && pacCntMatch && manufacturerIdMatch) return drug;
          }
          for (const drug of mappedDrugs) {
            const pacCntMatch = Number(drug.pacCnt) === Number(targetPacCnt);
            const manufacturerIdMatch = String(drug.prodentpNameId || '') === String(targetManufacturerId || '');
            if (pacCntMatch && manufacturerIdMatch) return drug;
          }
        }
        return null;
      } catch (error) {
        console.error('执行药品匹配搜索失败:', error);
        return null;
      }
    },

    createMedicineRow(params, hasTraceCode = false) {
      const {
        drugId, drugName, manufacturer, manufacturerId, approvalLicenceNo,
        spec, pacSpec, dosUnt, pacUnt, pacCnt,
        outQuantity = '', purcType, isBar,
        traceCodes, tracCodeJson, refEntId, unitLabel,
        manuLotnum, manuDate, expyDate, drugType, costPricStr, purcCnt = ''
      } = params;
      const finalIsBar = (this.getSomeWareData && this.getSomeWareData.isBar === 1) ? 1 : (isBar || 0);
      const hasTraceCodeFinal = hasTraceCode && finalIsBar === 1;
      const traceCodesCount = (traceCodes && traceCodes.length) || 0;
      const finalCostPricStr = costPricStr !== undefined && costPricStr !== null && costPricStr !== '' ? String(costPricStr) : '0';
      const costPricNum = parseFloat(finalCostPricStr) || 0;
      const qty = outQuantity !== '' ? parseFloat(outQuantity) || 0 : '';
      return {
        id: Date.now() + Math.random(), drugId: drugId || '', drugName: drugName || '',
        outQuantity: qty, stockType: purcType || 2, pacCnt: pacCnt || 1,
        purcCnt: purcCnt || '', manuLotnum: manuLotnum || '', manuDate: manuDate || '',
        expyDate: expyDate || '', prodentpName: manufacturer || '', prodentpNameId: manufacturerId || '',
        purcPric: costPricNum, salePric: costPricNum,
        currentOutCost: costPricNum * (qty || 0), currentOutSale: costPricNum * (qty || 0),
        drugSpec: spec || '', dosUnt: dosUnt || '', pacUnt: pacUnt || '', unitLabel: unitLabel || '',
        isBar: finalIsBar, traceCodes: traceCodes || [], tracCodeJson: tracCodeJson || '',
        traceCodeButtonText: hasTraceCodeFinal && finalIsBar === 1 ? `追溯码(${traceCodesCount})` : '追溯码',
        isNewRow: true, refEntId: refEntId || '', label: drugName, drugType: drugType || 1,
        invId: null, isLocked: false, isEditing: this.isEditMode, verified: false, checkingStock: false,
        isFixedPriceText: '未指定', markUpId: 1, isFixPrice: 0, markUpRatio: 0, markUpAmount: 0
      };
    },

    async handleConfirmTraceCodeInput() {
      const loadingInstance = this.$loading({ lock: true, text: '正在检查药品库...', background: 'rgba(0,0,0,0.7)' });
      try {
        let wareData = this.getSomeWareData;
        if (Array.isArray(wareData) && wareData.length > 0) wareData = wareData[0];
        if (!wareData) { this.$message.warning('没有找到对应的药品档案，请先添加该药品！'); loadingInstance.close(); return; }
        if (!this.validateTraceCodeInputForm()) { this.$message.warning('请填写所有必填项'); loadingInstance.close(); return; }
        const matchedDrug = await this.performDrugMatch();
        if (!matchedDrug) { this.$message.warning('未在药品库中找到匹配的药品（药品ID、包装数量、生产厂商ID不一致），请检查药品目录或重新录入'); loadingInstance.close(); return; }
        const traceCode = this.traceCodeInputForm.traceCode;
        if (this.checkIfTraceCodeAlreadyAdded(traceCode)) { this.$message.error('该追溯码已存在，请勿重复录入！'); loadingInstance.close(); return; }
        const traceCodeData = this.traceCodeDetailData;
        const drugInfo = traceCodeData.drugEntBaseDTO || {};
        const entInfo = traceCodeData.pUserEntDTO || {};
        const produceInfoList = traceCodeData.codeProduceInfoDTO?.produceInfoList || [];
        const produceInfo = produceInfoList[0] || {};
        const refEntId = entInfo?.refEntId || '';
        const originalDrugId = matchedDrug.drugId || matchedDrug.id;
        const safeDrugId = originalDrugId ? String(originalDrugId) : '';
        const drugName = matchedDrug.drugName || drugInfo.physicName || '';
        const manufacturer = matchedDrug.prodentpName || entInfo.entName || '';
        const approvalLicenceNo = matchedDrug.approvalLicenceNo || drugInfo.approvalLicenceNo || '';
        const pacCnt = matchedDrug.pacCnt || this.traceCodeInputForm.pacCnt || 1;
        const dosUnt = matchedDrug.dosUnt || '最小单位';
        const pacUnt = matchedDrug.pacUnt || '包装单位';
        const pacSpec = matchedDrug.pacSpec || '';
        const isBar = matchedDrug.isBar || 0;
        const manuLotnum = produceInfo.batchNo || matchedDrug.manuLotnum || '';
        const manuDate = produceInfo.produceDateStr || matchedDrug.manuDate || '';
        const expyDate = produceInfo.originalExpireDate || matchedDrug.expyDate || '';
        const purcCnt = matchedDrug.purcCnt || '';
        let costPricStr = '0';
        if (matchedDrug.costPric !== undefined && matchedDrug.costPric !== null) costPricStr = String(matchedDrug.costPric);
        else if (matchedDrug.purcPric !== undefined && matchedDrug.purcPric !== null) costPricStr = String(matchedDrug.purcPric);
        const costPricNum = parseFloat(costPricStr);
        if (isNaN(costPricNum) || costPricNum <= 0) costPricStr = '0';
        const traceCodes = [{ traceCode: traceCode, drugName: drugName, manufacturer: manufacturer, batchNo: manuLotnum, availableQty: pacCnt }];
        const hasTraceCode = traceCodes && traceCodes.length > 0;
        let tracCodeJson = [];
        if (hasTraceCode && isBar === 1) {
          tracCodeJson = traceCodes.map(item => ({ barcode: item.traceCode, chgCnt: pacCnt, manuLotnum: manuLotnum }));
        }
        const tracCodeJsonString = tracCodeJson.length > 0 ? JSON.stringify(tracCodeJson) : '';
        const newMedicine = this.createMedicineRow({
          drugId: safeDrugId, drugName, manufacturer,
          manufacturerId: matchedDrug.prodentpNameId || this.traceCodeInputForm.manufacturerId,
          approvalLicenceNo, spec: matchedDrug.drugSpec || drugInfo.pkgSpecCrit || '',
          pacSpec, dosUnt, pacUnt, pacCnt, outQuantity: '', purcType: 2, isBar, traceCodes,
          tracCodeJson: tracCodeJsonString, refEntId, unitLabel: pacUnt, manuLotnum, manuDate, expyDate,
          drugType: matchedDrug.drugType || 1, costPricStr, purcCnt
        }, hasTraceCode && isBar === 1);
        newMedicine.invId = matchedDrug.invyId || matchedDrug.invId || null;
        this.medicineList.push(newMedicine);
        if (safeDrugId) {
          const drugOption = {
            id: safeDrugId, drugId: safeDrugId, drugName, label: drugName,
            drugSpec: matchedDrug.drugSpec || '', pacSpec, pacCnt, dosUnt, pacUnt,
            prodentpName: manufacturer, isBar, drugType: matchedDrug.drugType || 1,
            manufacturerId: matchedDrug.prodentpNameId || '',
            costPric: parseFloat(costPricStr) || 0, invyId: newMedicine.invId
          };
          if (!this.drugOptions.some(item => String(item.id) === String(drugOption.id) || String(item.drugId) === String(drugOption.drugId))) {
            this.drugOptions.push(drugOption);
            this.allDrugOptions.push(drugOption);
          }
          this.$forceUpdate();
        }
        this.$message.success(`已成功添加药品: ${drugName}，出库数量请手动输入`);
        this.traceCodeInputDialogVisible = false;
        this.resetTraceCodeInputForm();
        loadingInstance.close();
      } catch (error) {
        console.error('添加药品失败:', error);
        this.$message.error('添加药品失败: ' + error.message);
        loadingInstance.close();
      }
    },

    handleClearTraceCode() {
      this.$confirm('确定清空所有追溯码吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => { this.traceCodeList = []; this.$message.success('已清空所有追溯码'); }).catch(() => {});
    },
    handleImportTraceCode() { this.$message.info('导入功能待实现'); },
    handleExportTraceCode() { this.$message.info('导出功能待实现'); },

    // ============================================================
    // 过单进度 / 提交上传进度
    // ============================================================
    updateStep(index, status, title = null, description = null) {
      this.traceCodeUploadStep = index;
      if (title) this.traceCodeUploadSteps[index].title = title;
      if (description) this.traceCodeUploadSteps[index].description = description;
      if (status) this.traceCodeUploadSteps[index].status = status;
    },

    async updateStepWithDelay(index, status, title, description) {
      this.updateStep(index, status, title, description);
      await this.delay(2000);
    },

    startSlowResponseTimer() {
      this.clearSlowResponseTimer();
      this.slowResponseShown = false;
      this.slowResponseTimer = setTimeout(() => {
        if (this.msfxUploading) this.slowResponseShown = true;
      }, 8000);
    },

    clearSlowResponseTimer() {
      if (this.slowResponseTimer) {
        clearTimeout(this.slowResponseTimer);
        this.slowResponseTimer = null;
      }
      this.slowResponseShown = false;
    },

    handleSlowResponseClick() {
      this.slowResponseCancelled = true;
      this.passProgressDialogVisible = false;
      this.msfxUploading = false;
      this.saving = false;
      this.passLoading = false;
      this.clearSlowResponseTimer();
      this.resetTraceCodeUpload();
      this.resetSubmitUploadState();
    },

    handleCheckBill() {
      this.showErrorOptions = false;
      this.passProgressDialogVisible = false;
      this.resetTraceCodeUpload();
      if (this.isSubmitUploadMode) {
        this.$message.info('请检查单据信息后重新点击"保存提交"');
      } else {
        this.$message.info('请检查单据信息后重新点击"确认出库"');
      }
      this.saving = false;
      this.resetSubmitUploadState();
    },

    async handleContinuePass() {
      this.showErrorOptions = false;
      if (this.isSubmitUploadMode) {
        this.addTraceCodeUploadDetail('用户选择继续提交，正在执行...', 'info');
        this.updateStep(3, 'success', null, '追溯码上传失败，继续提交中');
        await this.continueSubmitAfterUpload();
      } else {
        this.addTraceCodeUploadDetail('用户选择继续过单，正在执行...', 'info');
        this.updateStep(3, 'success', null, '追溯码上传失败，继续过单中');
        await this.continuePassAfterUpload();
      }
    },

    async continuePassAfterUpload() {
      if (this.passContinuing) return;
      this.passContinuing = true;
      try {
        this.updateStep(4, 'process', null, '正在执行过单操作...');
        this.addTraceCodeUploadDetail('正在执行过单操作...', 'info');
        const passResp = await toRetnExamine({ id: this.rowData.id, state: 5 });

        if (this.slowResponseCancelled) return;

        const isPassSuccess = passResp && (passResp.code == 200 || passResp.code === '200');

        if (isPassSuccess) {
          this.addTraceCodeUploadDetail('过单成功！', 'success');
          this.traceCodeUploadSteps[4].description = '过单成功！';
          this.traceCodeUploadSteps[4].status = 'success';
          this.showCloseButton = true;
          this.traceCodeUploadStep = 4;
          this.totalProgress = 100;
          this.autoCloseTimer = setTimeout(() => {
            this.passProgressDialogVisible = false;
            this.resetTraceCodeUpload();
            this.$message.success('出库过单完成！');
            this.$emit('success');
            this.handleClose();
          }, 2000);
        } else {
          const msg = passResp?.message || '未知错误';
          this.addTraceCodeUploadDetail('过单失败：' + msg, 'error');
          this.traceCodeUploadSteps[4].description = '过单失败：' + msg;
          this.traceCodeUploadSteps[4].status = 'error';
          this.traceCodeHasError = true;
          this.showCloseButton = true;
          this.$message.error('过单失败：' + msg);
        }
      } catch (error) {
        console.error('过单异常:', error);
        this.addTraceCodeUploadDetail('过单异常：' + error.message, 'error');
        this.traceCodeHasError = true;
        this.showCloseButton = true;
        this.$message.error('过单失败: ' + (error.message || '网络错误'));
      } finally {
        this.passContinuing = false;
      }
    },

    // ============================================================
    // ✅ 提交前上传追溯码入口（新增）
    // ============================================================
    async startSubmitUploadFlow(operationType, validList) {
      this.submitOperationType = operationType;
      this.submitValidList = validList;
      this.isSubmitUploadMode = true;

      this.saving = true;
      this.passProgressDialogVisible = true;
      this.resetTraceCodeUpload();
      this.traceCodeUploadSteps[4] = { title: '提交审核', description: '正在提交单据...', status: '' };
      this.addTraceCodeUploadDetail('开始准备提交...', 'info');

      try {
        this.updateStep(0, 'process', null, '正在检查是否有药品需要录入追溯码...');
        this.addTraceCodeUploadDetail('正在检查是否有药品需要录入追溯码...', 'info');
        await this.checkNeedUploadTraceCode();
        await this.updateStepWithDelay(0, 'success');

        this.updateStep(1, 'process', null, '正在接入码上放心平台接口...');
        this.addTraceCodeUploadDetail('正在接入码上放心平台接口...', 'info');
        if (!this.systemParameterList || this.systemParameterList.length === 0) {
          const paramSuccess = await this.getSystemParameters();
          if (paramSuccess) {
            this.addTraceCodeUploadDetail('系统参数获取成功', 'success');
          } else {
            this.addTraceCodeUploadDetail('系统参数获取失败，将使用默认值', 'warning');
          }
        } else {
          this.addTraceCodeUploadDetail('系统参数已加载', 'success');
        }
        await this.updateStepWithDelay(1, 'success', null, '码上放心平台接口接入完成');

        this.updateStep(2, 'process', null, '正在上传出库明细追溯码数据...');
        this.addTraceCodeUploadDetail('正在上传出库明细追溯码数据...', 'info');

        let uploadResult = { success: true, skip: true, cancelled: false, message: '' };

        if (this.needUploadTraceCode) {
          await this.extractTraceCodes();
          if (this.traceCodeCount > 0) {
            this.startSlowResponseTimer();
            try {
              uploadResult = await this.uploadTraceCodes();
            } finally {
              this.clearSlowResponseTimer();
            }

            if (uploadResult.cancelled || this.slowResponseCancelled) {
              return;
            }

            if (uploadResult.success) {
              this.uploadResultType = 'success';
              this.uploadResultMessage = '';
              this.msfxUploadSuccess = true;
              this.traceCodeHasError = false;
              this.updateStep(2, 'success', null, '追溯码上传成功！√');
              this.addTraceCodeUploadDetail('追溯码上传成功！√', 'success');
              await this.delay(1500);
              this.updateStep(3, 'success', null, '追溯码已上传至码上放心平台。');
              this.addTraceCodeUploadDetail('追溯码已上传至码上放心平台。', 'success');
              await this.continueSubmitAfterUpload();
              return;
            } else {
              this.uploadResultType = 'error';
              this.uploadResultMessage = uploadResult.message || '未知错误';
              this.msfxUploadSuccess = false;
              this.traceCodeHasError = true;
              this.updateStep(2, 'error', null, '追溯码上传失败！' + this.uploadResultMessage);
              this.addTraceCodeUploadDetail('追溯码上传失败！' + this.uploadResultMessage, 'error');
              this.addTraceCodeUploadDetail('您可点击下方【检查单据】或【继续提交】', 'warning');
              this.showErrorOptions = true;
              return;
            }
          } else {
            uploadResult.skip = true;
            this.updateStep(2, 'success', null, '没有有效的追溯码需要上传');
            this.addTraceCodeUploadDetail('没有有效的追溯码需要上传', 'warning');
          }
        } else {
          uploadResult.skip = true;
          this.updateStep(2, 'success', null, '没有需要上传追溯码的药品');
          this.addTraceCodeUploadDetail('没有需要上传追溯码的药品', 'warning');
        }

        await this.delay(1000);
        this.updateStep(3, 'success', null, '无追溯码需要上传');
        this.addTraceCodeUploadDetail('无追溯码需要上传，跳过此步骤', 'info');
        await this.continueSubmitAfterUpload();
      } catch (error) {
        console.error('提交失败:', error);
        this.clearSlowResponseTimer();
        if (this.slowResponseCancelled) return;
        this.addTraceCodeUploadDetail('提交异常：' + error.message, 'error');
        this.traceCodeHasError = true;
        this.showCloseButton = true;
        this.$message.error('提交失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
        this.passLoading = false;
        this.clearSlowResponseTimer();
      }
    },

    async continueSubmitAfterUpload() {
      if (this.passContinuing) return;
      this.passContinuing = true;
      try {
        this.updateStep(4, 'process', null, '正在提交单据...');
        this.addTraceCodeUploadDetail('正在提交单据...', 'info');

        let response;
        if (this.submitOperationType === 'create') {
          let costAmt = 0, saleAmt = 0;
          const list = this.buildListData();
          list.forEach(item => {
            costAmt += item.retnAmt || 0;
            saleAmt += item.saleAmt || 0;
          });
          const requestData = {
            costAmt, list, retnTypeId: this.formData.retnTypeId || '',
            remarks: this.formData.remark || '', saleAmt,
            shedId: this.formData.warehouseId || 1, state: 2,
            supplyCandidateId: this.formData.supplierId || 0,
            supplyCode: this.formData.supplierCode || '', deptId: this.formData.deptId || ''
          };
          response = await addOutbound(requestData);
        } else if (this.submitOperationType === 'edit') {
          const requestData = this.buildRequestData(2);
          response = await editdocOut(requestData);
        }

        if (this.slowResponseCancelled) return;

        const isSuccess = response && (response.code == 200 || response.code === '200');

        if (isSuccess) {
          this.addTraceCodeUploadDetail('提交成功！', 'success');
          this.traceCodeUploadSteps[4].description = '提交成功！';
          this.traceCodeUploadSteps[4].status = 'success';
          this.showCloseButton = true;
          this.traceCodeUploadStep = 4;
          this.totalProgress = 100;
          this.autoCloseTimer = setTimeout(() => {
            this.passProgressDialogVisible = false;
            this.resetTraceCodeUpload();
            this.$message.success('提交成功');
            this.$emit('success');
            this.handleClose();
          }, 1500);
        } else {
          const msg = (response && response.message) || '未知错误';
          this.addTraceCodeUploadDetail('提交失败：' + msg, 'error');
          this.traceCodeUploadSteps[4].description = '提交失败：' + msg;
          this.traceCodeUploadSteps[4].status = 'error';
          this.traceCodeHasError = true;
          this.showCloseButton = true;
          this.$message.error('提交失败：' + msg);
        }
      } catch (error) {
        console.error('提交异常:', error);
        this.addTraceCodeUploadDetail('提交异常：' + error.message, 'error');
        this.traceCodeHasError = true;
        this.showCloseButton = true;
        this.$message.error('提交失败: ' + (error.message || '网络错误'));
      } finally {
        this.passContinuing = false;
        this.saving = false;
      }
    },

    resetTraceCodeUpload() {
      this.traceCodeUploadStep = 0;
      this.traceCodeUploadSteps = [
        { title: '检查追溯码', description: '正在检查是否有药品需要录入追溯码...', status: '' },
        { title: '接入码上放心', description: '正在接入码上放心平台接口...', status: '' },
        { title: '上传追溯码', description: '正在上传出库明细追溯码数据...', status: '' },
        { title: '完成上传', description: '追溯码已上传至码上放心平台。', status: '' },
        { title: '完成出库', description: '已完成出库。', status: '' }
      ];
      this.traceCodeUploadDetails = [];
      this.traceCodeHasError = false;
      this.showRetryButton = false;
      this.uploadRetryCount = 0;
      this.msfxUploading = false;
      this.msfxUploadError = '';
      this.msfxUploadSuccess = true;

      this.uploadResultType = '';
      this.uploadResultMessage = '';
      this.showErrorOptions = false;
      this.slowResponseShown = false;
      this.slowResponseCancelled = false;
      this.userActionResolve = null;
      this.passContinuing = false;

      if (this.slowResponseTimer) { clearTimeout(this.slowResponseTimer); this.slowResponseTimer = null; }
      if (this.autoCloseTimer) { clearTimeout(this.autoCloseTimer); this.autoCloseTimer = null; }
    },

    resetSubmitUploadState() {
      this.isSubmitUploadMode = false;
      this.submitOperationType = null;
      this.submitValidList = null;
    },

    addTraceCodeUploadDetail(message, type = 'info') {
      const now = new Date();
      const time = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
      this.traceCodeUploadDetails.push({ message, type, time });
      this.$nextTick(() => {
        const container = this.$refs.uploadDetailsContainer;
        if (container) container.scrollTop = container.scrollHeight;
      });
    },
    getStepStatus(index) {
      const step = this.traceCodeUploadSteps[index];
      if (step && step.status) return step.status;
      if (this.traceCodeHasError && index === this.traceCodeUploadStep) return 'error';
      if (index < this.traceCodeUploadStep) return 'finish';
      if (index === this.traceCodeUploadStep) return 'process';
      return 'wait';
    },
    getDetailIcon(type) {
      switch (type) {
        case 'success': return 'el-icon-success';
        case 'error': return 'el-icon-error';
        case 'warning': return 'el-icon-warning';
        default: return 'el-icon-info';
      }
    },
    handleUploadCancel() {
      this.$confirm('确定要取消上传吗？取消后需要重新开始。', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.slowResponseCancelled = true;
        this.passProgressDialogVisible = false;
        this.saving = false;
        this.resetTraceCodeUpload();
        this.resetSubmitUploadState();
      });
    },
    closeTraceCodeUploadDialog() {
      this.passProgressDialogVisible = false;
      this.resetTraceCodeUpload();
      this.resetSubmitUploadState();
      this.$emit('success');
      this.handleClose();
    },
    resetPassProgress() { this.resetTraceCodeUpload(); },
    updateProgressStep(index, status, title = null, description = null) {
      this.updateStep(index, status, title, description);
    },
    formatTotalProgress(percentage) { return `总进度: ${percentage}%`; },
    handleCloseProgressDialog() {
      this.passProgressDialogVisible = false;
      this.$emit('success');
      this.handleClose();
    },
    handleProgressDialogClose(done) {
      if (this.showCloseButton) { this.$emit('success'); done(); }
      else if (this.passLoading) {
        this.$confirm('上传正在进行中，确定要关闭吗？', '提示', { type: 'warning' })
          .then(() => { this.$emit('success'); done(); }).catch(() => {});
      } else { this.$emit('success'); done(); }
    },
    async checkNeedUploadTraceCode() {
      this.needUploadTraceCode = false;
      this.needUploadDrugs = [];
      this.medicineList.forEach(item => {
        if (item.tracCodeJson && item.tracCodeJson.trim() !== '' && item.tracCodeJson !== '[]') {
          this.needUploadTraceCode = true;
          this.needUploadDrugs.push({
            drugName: item.drugName,
            tracCodeJson: item.tracCodeJson,
            refEntId: item.refEntId || ''
          });
        }
      });
      if (this.needUploadTraceCode && this.needUploadDrugs.length > 0) {
        const drugNames = this.needUploadDrugs.map(drug => drug.drugName).join('、');
        this.addTraceCodeUploadDetail(`检测到 ${drugNames} 需要上传追溯码`, 'success');
      } else {
        this.addTraceCodeUploadDetail('本次单据无需上传追溯码', 'info');
      }
    },
    async extractTraceCodes() {
      try {
        const allTraceCodes = [];
        this.needUploadDrugs.forEach(drug => {
          try {
            const tracCodeJson = JSON.parse(drug.tracCodeJson);
            if (Array.isArray(tracCodeJson)) {
              tracCodeJson.forEach(item => { if (item.barcode) allTraceCodes.push(item.barcode); });
            }
          } catch (parseError) {
            console.error('解析追溯码JSON失败:', parseError, drug);
          }
        });
        this.traceCodeCount = allTraceCodes.length;
        this.traceCodeString = allTraceCodes.join(', ');
        this.addTraceCodeUploadDetail(`共提取到 ${this.traceCodeCount} 个追溯码`, 'success');
      } catch (error) {
        console.error('提取追溯码失败:', error);
        throw error;
      }
    },
    // ✅ 上传追溯码（已移除 bizNum 字段）
    async uploadTraceCodes() {
      this.msfxUploading = true;
      try {
        if (!this.traceCodeString) return { success: true, message: '无追溯码需要上传' };
        const fromUserId = this.formData?.entId || this.rowData?.entId || '';
        if (!fromUserId) return { success: false, message: '缺少供应商ID（supplyCandidateId）' };
        const toUserId = this.msfxEntId || 'default_ent_id';
        const uploadData = {
          billType: 202,
          fromUserId: fromUserId,
          physicType: 3,
          toUserId: toUserId,
          traceCodes: this.traceCodeString.replace(/,\s*/g, ',')
        };
        if (!uploadData.traceCodes) return { success: false, message: '追溯码为空' };
        this.addTraceCodeUploadDetail('正在上传追溯码到码上放心平台...', 'info');
        const response = await msfxUploadInoutBill(uploadData);

        if (this.slowResponseCancelled) {
          return { success: false, cancelled: true, message: '' };
        }

        const isSuccess = response && (response.code == 200 || response.code === '200');

        if (isSuccess) {
          this.addTraceCodeUploadDetail('追溯码上传成功', 'success');
          return { success: true, message: '上传成功' };
        } else {
          const msg = response?.message || response?.msg || '未知错误';
          this.addTraceCodeUploadDetail('上传失败：' + msg, 'error');
          return { success: false, message: msg };
        }
      } catch (error) {
        console.error('上传追溯码失败:', error);
        if (this.slowResponseCancelled) return { success: false, cancelled: true, message: '' };
        this.addTraceCodeUploadDetail('上传异常：' + error.message, 'error');
        return { success: false, message: error.message || '网络错误' };
      } finally {
        this.msfxUploading = false;
      }
    },
    getBillType(retnTypeId) {
      const typeMap = { 1: 102, 2: 113, 3: 111, 4: 111, 5: 111 };
      return typeMap[retnTypeId] || 102;
    },

    // ============================================================
    // 过单入口
    // ============================================================
    async handlePassConfirm() {
      if (this.mode !== 'pass') return;
      for (const medicine of this.medicineList) {
        if (medicine.isBar === 1 && (!medicine.tracCodeJson || medicine.tracCodeJson.length === 0)) {
          this.$message.warning(`药品「${medicine.drugName}」需录入追溯码才能过单`);
          return;
        }
      }
      try {
        this.saving = true;
        this.passProgressDialogVisible = true;
        this.resetTraceCodeUpload();
        this.isSubmitUploadMode = false;
        this.addTraceCodeUploadDetail('开始准备过单...', 'info');

        this.updateStep(0, 'process', null, '正在检查是否有药品需要录入追溯码...');
        this.addTraceCodeUploadDetail('正在检查是否有药品需要录入追溯码...', 'info');
        await this.checkNeedUploadTraceCode();
        await this.updateStepWithDelay(0, 'success');

        this.updateStep(1, 'process', null, '正在接入码上放心平台接口...');
        this.addTraceCodeUploadDetail('正在接入码上放心平台接口...', 'info');
        const paramSuccess = await this.getSystemParameters();
        if (paramSuccess) {
          this.addTraceCodeUploadDetail('系统参数获取成功', 'success');
        } else {
          this.addTraceCodeUploadDetail('系统参数获取失败，将使用默认值', 'warning');
        }
        await this.updateStepWithDelay(1, 'success', null, '码上放心平台接口接入完成');

        this.updateStep(2, 'process', null, '正在上传出库明细追溯码数据...');
        this.addTraceCodeUploadDetail('正在上传出库明细追溯码数据...', 'info');

        let uploadResult = { success: true, skip: true, cancelled: false, message: '' };

        if (this.needUploadTraceCode) {
          await this.extractTraceCodes();
          if (this.traceCodeCount > 0) {
            this.startSlowResponseTimer();
            try {
              uploadResult = await this.uploadTraceCodes();
            } finally {
              this.clearSlowResponseTimer();
            }

            if (uploadResult.cancelled || this.slowResponseCancelled) {
              return;
            }

            if (uploadResult.success) {
              this.uploadResultType = 'success';
              this.uploadResultMessage = '';
              this.msfxUploadSuccess = true;
              this.traceCodeHasError = false;
              this.updateStep(2, 'success', null, '追溯码上传成功！√');
              this.addTraceCodeUploadDetail('追溯码上传成功！√', 'success');
              await this.delay(2000);
              this.updateStep(3, 'success', null, '追溯码已上传至码上放心平台。');
              this.addTraceCodeUploadDetail('追溯码已上传至码上放心平台。', 'success');
              await this.continuePassAfterUpload();
              return;
            } else {
              this.uploadResultType = 'error';
              this.uploadResultMessage = uploadResult.message || '未知错误';
              this.msfxUploadSuccess = false;
              this.traceCodeHasError = true;
              this.updateStep(2, 'error', null, '追溯码上传失败！' + this.uploadResultMessage);
              this.addTraceCodeUploadDetail('追溯码上传失败！' + this.uploadResultMessage, 'error');
              this.addTraceCodeUploadDetail('您可点击下方【检查单据】或【继续过单】', 'warning');
              this.showErrorOptions = true;
              return;
            }
          } else {
            uploadResult.skip = true;
            this.updateStep(2, 'success', null, '没有有效的追溯码需要上传');
            this.addTraceCodeUploadDetail('没有有效的追溯码需要上传', 'warning');
          }
        } else {
          uploadResult.skip = true;
          this.updateStep(2, 'success', null, '没有需要上传追溯码的药品');
          this.addTraceCodeUploadDetail('没有需要上传追溯码的药品', 'warning');
        }

        await this.delay(2000);
        this.updateStep(3, 'success', null, '无追溯码需要上传');
        this.addTraceCodeUploadDetail('无追溯码需要上传，跳过此步骤', 'info');
        await this.continuePassAfterUpload();
      } catch (error) {
        console.error('过单失败:', error);
        this.clearSlowResponseTimer();
        if (this.slowResponseCancelled) return;
        this.addTraceCodeUploadDetail('过单异常：' + error.message, 'error');
        this.traceCodeHasError = true;
        this.showCloseButton = true;
        this.$message.error('过单失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
        this.passLoading = false;
        this.clearSlowResponseTimer();
      }
    },

    // ============================================================
    // 创建 / 编辑 / 提交 / 回退
    // ============================================================

    /**
     * 构建新建/修改的 list 数组（复用逻辑）
     */
    buildListData() {
      return this.medicineList.map(item => {
        const cost = parseFloat(item.currentOutCost) || 0;
        const qty = parseFloat(item.outQuantity) || 0;
        const purcAmt = cost;
        const saleAmtItem = parseFloat(item.currentOutSale) || 0;
        return {
          drugId: item.drugId || '', drugName: item.drugName || '',
          expyDate: item.expyDate || '', manuDate: item.manuDate || '',
          manuLotnum: item.manuLotnum || '', prodentpName: item.prodentpName || '',
          prodentpNameId: item.prodentpNameId || 0, retnAmt: purcAmt,
          drugType: item.drugType || 1, apllyAmt: qty, retnPric: cost,
          purcType: item.stockType || 0, saleAmt: saleAmtItem,
          salePric: parseFloat(item.salePric) || 0, tracCodeJson: item.tracCodeJson || '',
          invId: item.invId || 0, purcPric: parseFloat(item.purcPric) || 0,
          drugSpec: item.drugSpec || ''
        };
      });
    },

    /**
     * 【确认创建】add 模式 - 调用 addOutbound(state=0) 创建草稿
     */
    async handleCreate() {
      for (const medicine of this.medicineList) {
        if (!this.validateMedicine(medicine)) return;
      }
      try {
        this.saving = true;
        const valid = await this.$refs.inboundForm.validate();
        if (!valid) { this.saving = false; return; }
        if (this.medicineList.length === 0) { this.$message.warning('请至少添加一种药品'); this.saving = false; return; }

        let costAmt = 0, saleAmt = 0;
        const list = this.buildListData();
        list.forEach(item => {
          costAmt += item.retnAmt || 0;
          saleAmt += item.saleAmt || 0;
        });

        const requestData = {
          costAmt, list, retnTypeId: this.formData.retnTypeId || '',
          remarks: this.formData.remark || '', saleAmt,
          shedId: this.formData.warehouseId || 1, state: 0,
          supplyCandidateId: this.formData.supplierId || 0,
          supplyCode: this.formData.supplierCode || '', deptId: this.formData.deptId || ''
        };
        const response = await addOutbound(requestData);
        if (response.code === 200) {
          this.$message.success('出库单创建成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '创建出库单失败');
        }
      } catch (error) {
        console.error('创建出库单失败:', error);
        this.$message.error('创建出库单失败: ' + (error.message || '请检查供货单位等必填项是否填写完毕。'));
      } finally {
        this.saving = false;
      }
    },

    /**
     * 【保存提交】add 模式 - 未启用审核流程（value=0）时显示
     * - 未启用审核流程：先上传追溯码 → 上传成功后再提交
     * - 启用审核流程：直接提交（按钮本来就不显示，但保留兼容）
     */
    async handleCreateAndSubmit() {
      for (const medicine of this.medicineList) {
        if (!this.validateMedicine(medicine)) return;
      }
      try {
        const valid = await this.$refs.inboundForm.validate();
        if (!valid) return;
      } catch (e) {
        return;
      }
      if (this.medicineList.length === 0) {
        this.$message.warning('请至少添加一种药品');
        return;
      }

      const needUpload = this.shouldUploadTraceCodeBeforeSubmit();
      if (needUpload) {
        this.startSubmitUploadFlow('create', null);
        return;
      }

      await this.doCreateAndSubmit();
    },

    async doCreateAndSubmit() {
      try {
        this.saving = true;
        let costAmt = 0, saleAmt = 0;
        const list = this.buildListData();
        list.forEach(item => {
          costAmt += item.retnAmt || 0;
          saleAmt += item.saleAmt || 0;
        });

        const requestData = {
          costAmt, list, retnTypeId: this.formData.retnTypeId || '',
          remarks: this.formData.remark || '', saleAmt,
          shedId: this.formData.warehouseId || 1, state: 2,
          supplyCandidateId: this.formData.supplierId || 0,
          supplyCode: this.formData.supplierCode || '', deptId: this.formData.deptId || ''
        };
        const response = await addOutbound(requestData);
        if (response.code === 200) {
          this.$message.success('出库单创建并提交审核成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存提交失败');
        }
      } catch (error) {
        console.error('创建并提交失败:', error);
        this.$message.error('操作失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
      }
    },

    buildRequestData(state) {
      const list = this.buildListData();
      return {
        id: this.rowData.id || 0, costAmt: this.totalOutCost,
        invoDate: this.formData.businessDate || '', list,
        purcInvoCodg: this.formData.invoiceNo || '',
        retnTypeId: this.formData.retnTypeId || '',
        remarks: this.formData.remark || '', saleAmt: this.totalOutSale,
        shedId: this.formData.warehouseId || 1, state,
        supplyCandidateId: this.formData.supplierId || 0,
        supplyCode: this.formData.supplierCode || '', deptId: this.formData.deptId || ''
      };
    },

    /**
     * 【修改保存】edit 模式 - 调用 editdocOut(state=0)
     */
    async handleSave() {
      try {
        this.saving = true;
        const valid = await this.$refs.inboundForm.validate();
        if (!valid) { this.saving = false; return; }
        if (this.medicineList.length === 0) { this.$message.warning('请至少添加一种药品'); this.saving = false; return; }
        for (const medicine of this.medicineList) {
          if (!this.validateMedicine(medicine)) { this.saving = false; return; }
        }
        const requestData = this.buildRequestData(0);
        const response = await editdocOut(requestData);
        if (response.code === 200) {
          this.$message.success('修改保存成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存修改失败');
        }
      } catch (error) {
        console.error('保存修改失败:', error);
        this.$message.error('保存修改失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
      }
    },

    /**
     * 【保存提交】edit 模式
     * - inventoryAuditFlowEnabled = false（value=0）：先上传追溯码 → 上传成功后再提交
     * - inventoryAuditFlowEnabled = true（value=1）：直接提交
     */
    async handleSaveAndSubmit() {
      try {
        const valid = await this.$refs.inboundForm.validate();
        if (!valid) return;
      } catch (e) {
        return;
      }
      if (this.medicineList.length === 0) {
        this.$message.warning('请至少添加一种药品');
        return;
      }
      for (const medicine of this.medicineList) {
        if (!this.validateMedicine(medicine)) return;
      }

      const needUpload = this.shouldUploadTraceCodeBeforeSubmit();
      if (needUpload) {
        this.startSubmitUploadFlow('edit', null);
        return;
      }

      await this.doEditSubmit();
    },

    async doEditSubmit() {
      try {
        this.saving = true;
        const requestData = this.buildRequestData(2);
        const response = await editdocOut(requestData);
        if (response.code === 200) {
          this.$message.success('修改并提交审核成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存并提交失败');
        }
      } catch (error) {
        console.error('保存并提交失败:', error);
        this.$message.error('操作失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
      }
    },

    async handleSubmitConfirm() {
      this.saving = true;
      try {
        const response = await toRetnExamine({ id: this.rowData.id, state: 2 });
        if (response && response.code === 200) {
          this.$message.success('提交审核成功');
          this.$emit('success', response.data);
          this.dialogVisible = false;
        } else {
          this.$message.error(response.message || '提交审核失败');
        }
      } catch (error) {
        console.error('提交审核失败:', error);
        this.$message.error('提交审核失败');
      } finally {
        this.saving = false;
      }
    },
    async handleReviewConfirm() {
      this.saving = true;
      try {
        const response = await toRetnExamine({ id: this.rowData.id, state: 4 });
        if (response && response.code === 200) {
          this.$message.success('审核成功');
          this.$emit('success', response.data);
          this.dialogVisible = false;
        } else {
          this.$message.error(response.message || '审核失败');
        }
      } catch (error) {
        console.error('审核失败:', error);
        this.$message.error('审核失败');
      } finally {
        this.saving = false;
      }
    },
    async handleRollbackDraft() {
      if (this.mode !== 'review') return;
      try {
        this.saving = true;
        const response = await toRetnExamine({ id: this.rowData.id, state: 0 });
        if (response.code === 200) {
          this.$message.success('已回退到草稿状态');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退失败');
        }
      } catch (error) {
        console.error('回退失败:', error);
        this.$message.error('回退失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
      }
    },
    async handleRollbackReview() {
      if (this.mode !== 'pass') return;
      try {
        this.saving = true;
        const response = await toRetnExamine({ id: this.rowData.id, state: 2 });
        if (response.code === 200) {
          this.$message.success('已回退到审核通过状态');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退失败');
        }
      } catch (error) {
        console.error('回退失败:', error);
        this.$message.error('回退失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
      }
    },
    async handleRollbackConfirm() {
      if (this.mode !== 'rollback') return;
      try {
        this.saving = true;
        const response = await toRetnExamine({ id: this.rowData.id, state: 0 });
        if (response.code === 200) {
          this.$message.success('回退成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退失败');
        }
      } catch (error) {
        console.error('回退失败:', error);
        this.$message.error('回退失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
      }
    },
    async handleFastTransferConfirm() {
      if (this.mode !== 'fast') return;
      try {
        this.saving = true;
        const docNum = this.rowData?.docNum || '';
        if (!docNum) { this.$message.error('单据编号不存在'); this.saving = false; return; }
        const response = await fastTransfer({ docNum });
        if (response.code === 200) {
          this.$message.success('快速调拨成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.message || '快速调拨失败');
        }
      } catch (error) {
        console.error('快速调拨失败:', error);
        this.$message.error('快速调拨失败: ' + (error.message || '网络错误'));
      } finally {
        this.saving = false;
      }
    },

    validateMedicine(medicine) {
      const requiredFields = [
        { field: 'drugId', name: '药品名称' },
        { field: 'outQuantity', name: '出库数量' },
        { field: 'manuLotnum', name: '生产批号' },
        { field: 'manuDate', name: '生产日期' },
        { field: 'currentOutCost', name: '出库成本' }
      ];
      for (const { field, name } of requiredFields) {
        if (medicine[field] === undefined || medicine[field] === null || medicine[field] === '') {
          this.$message.warning(`请填写「${name}」`);
          return false;
        }
      }
      if (parseInt(medicine.periodControl) === 1 && !medicine.expyDate) {
        this.$message.warning('请填写「有效日期」');
        return false;
      }
      const qty = parseFloat(medicine.outQuantity);
      if (isNaN(qty) || qty <= 0) { this.$message.warning('「出库数量」必须大于0'); return false; }
      const cost = parseFloat(medicine.currentOutCost);
      if (isNaN(cost) || cost <= 0) { this.$message.warning('「出库成本」必须为正数且不能为0'); return false; }
      const costStr = String(medicine.currentOutCost);
      const decimalPart = costStr.includes('.') ? costStr.split('.')[1] : '';
      if (decimalPart.length > this.maxDecimalPlaces) {
        this.$message.warning(`「出库成本」小数位数不能超过${this.maxDecimalPlaces}位`);
        return false;
      }
      return true;
    },

    handleClose() {
      this.dialogVisible = false;
      this.resetTraceCodeUpload();
      this.resetSubmitUploadState();
      this.$emit('close');
    },

    // ============================================================
    // 追溯码辅助方法
    // ============================================================
    async handleTraceCodeSetting(row, index) {
      if (!row) return;
      const code = (row.traceCode || '').trim();
      if (!code) { this.$message.warning('追溯码为空，无法获取详情'); return; }
      const duplicate = this.traceCodeList.some((item, idx) => idx !== index && (item.traceCode || '').trim() === code);
      if (duplicate) { this.$message.warning('该追溯码与已有追溯码重复'); return; }
      const loadingInstance = this.$loading({ lock: true, text: '正在查询追溯码最新信息...', background: 'rgba(0,0,0,0.7)' });
      try {
        const response = await msfxCodeDetail({ codes: code });
        if (!response || response.code !== 200 || !response.data || response.data.length === 0) {
          this.$message.warning(response?.message || '未找到追溯码最新信息');
          return;
        }
        const traceCodeData = response.data[0];
        const drugInfo = traceCodeData.drugEntBaseDTO || {};
        const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
        const entInfo = traceCodeData.pUserEntDTO || {};
        const codeStatus = traceCodeData.codeStatusTypeDTO || {};
        let remark = '';
        if (produceInfo.produceDateStr) remark += `生产日期: ${produceInfo.produceDateStr}`;
        if (produceInfo.originalExpireDate) remark += (remark ? ', ' : '') + `有效期: ${produceInfo.originalExpireDate}`;
        if (drugInfo.approvalLicenceNo) remark += (remark ? ', ' : '') + `批准文号: ${drugInfo.approvalLicenceNo}`;
        if (codeStatus.codeStatus) remark += (remark ? ', ' : '') + `码状态: ${codeStatus.codeStatus}`;
        this.$set(this.traceCodeList, index, {
          ...this.traceCodeList[index],
          drugName: drugInfo.physicName || this.traceCodeList[index].drugName || '',
          spec: drugInfo.prepnSpec || drugInfo.pkgSpecCrit || this.traceCodeList[index].spec || '',
          manufacturer: entInfo.entName || this.traceCodeList[index].manufacturer || '',
          remark: remark || this.traceCodeList[index].remark || '',
          batchNo: produceInfo.batchNo || this.traceCodeList[index].batchNo || '',
          approvalLicenceNo: drugInfo.approvalLicenceNo || this.traceCodeList[index].approvalLicenceNo || '',
          produceDate: produceInfo.produceDateStr || this.traceCodeList[index].produceDate || '',
          expireDate: produceInfo.originalExpireDate || this.traceCodeList[index].expireDate || '',
          originalProduceDate: produceInfo.originalProduceDate || this.traceCodeList[index].originalProduceDate || '',
          pkgAmount: produceInfo.pkgAmount || this.traceCodeList[index].pkgAmount || '',
          physicTypeDesc: drugInfo.physicTypeDesc || this.traceCodeList[index].physicTypeDesc || '',
          prepnTypeDesc: drugInfo.prepnTypeDesc || this.traceCodeList[index].prepnTypeDesc || '',
          codeStatus: codeStatus.codeStatus || this.traceCodeList[index].codeStatus || '',
          packageLevel: traceCodeData.packageLevel || this.traceCodeList[index].packageLevel || ''
        });
        const cur = this.traceCodeList[index];
        if (!cur.availableQty || cur.availableQty <= 0) {
          const pkgAmount = parseInt(cur.pkgAmount) || 1;
          this.$set(cur, 'availableQty', pkgAmount);
        }
        const maxAvailable = this.getMaxAvailableQty(cur);
        if (parseInt(cur.availableQty) > maxAvailable) this.$set(cur, 'availableQty', maxAvailable);
        this.calculateTotalTraceQty();
        this.$message.success('追溯码信息已刷新');
      } catch (error) {
        console.error('刷新追溯码信息失败:', error);
        this.$message.error('刷新追溯码信息失败: ' + (error.message || '网络错误'));
      } finally {
        loadingInstance.close();
      }
    },
    validateTraceCode(row) {
      if (!row) return false;
      const code = (row.traceCode || '').trim();
      if (!code) { this.$message.warning('追溯码不能为空'); return false; }
      if (/[\u4e00-\u9fa5]/.test(code)) { this.$message.warning('追溯码不能包含中文'); return false; }
      const duplicateIndex = this.traceCodeList.findIndex((item) => item !== row && (item.traceCode || '').trim() === code);
      if (duplicateIndex !== -1) { this.$message.warning('追溯码不能重复'); return false; }
      if (!row.availableQty || parseInt(row.availableQty) <= 0) {
        const pkgAmount = parseInt(row.pkgAmount) || 1;
        this.$set(row, 'availableQty', pkgAmount);
        this.calculateTotalTraceQty();
      }
      return true;
    },
    getMaxAvailableQty(row) {
      if (!row) return 999;
      const pkgAmount = parseInt(row.pkgAmount);
      if (!isNaN(pkgAmount) && pkgAmount > 0) return pkgAmount;
      const pacCnt = this.currentTraceMedicine ? parseInt(this.currentTraceMedicine.pacCnt) : 0;
      if (!isNaN(pacCnt) && pacCnt > 0) return pacCnt;
      return 999;
    },
    handleAvailableQtyChange(row, index) {
      if (!row) return;
      const minVal = 1;
      const maxVal = this.getMaxAvailableQty(row);
      let qty = parseInt(row.availableQty);
      if (isNaN(qty) || qty < minVal) qty = minVal;
      else if (qty > maxVal) { qty = maxVal; this.$message.warning(`可用数量不能超过 ${maxVal}`); }
      this.$set(row, 'availableQty', qty);
      if (this.traceCodeList && this.traceCodeList.indexOf(row) !== -1) this.calculateTotalTraceQty();
    },
    handleTraceCodeBlur(row, index) {
      if (!row) return;
      const code = (row.traceCode || '').trim();
      if (!code) return;
      if (/[\u4e00-\u9fa5]/.test(code)) { this.$message.warning('追溯码不能包含中文'); return; }
      const duplicateIndex = this.traceCodeSupplementList.findIndex((item, idx) => idx !== index && (item.traceCode || '').trim() === code);
      if (duplicateIndex !== -1) this.$message.warning('追溯码不能重复');
    },
    canEditAvailableQty(row) { return !!(row && row.isEditing); },
    handleAvailableQtyBlur(row, index) {
      if (!row) return;
      const minVal = 1;
      const maxVal = this.getMaxAvailableQty(row);
      let qty = parseInt(row.availableQty);
      if (isNaN(qty) || qty < minVal) qty = minVal;
      else if (qty > maxVal) { qty = maxVal; this.$message.warning(`可用数量不能超过 ${maxVal}`); }
      this.$set(row, 'availableQty', qty);
    },
    getCodeStatusType(codeStatus) {
      if (!codeStatus) return 'info';
      const status = String(codeStatus).trim();
      if (['正常', '激活', '未使用', '有效', 'active'].includes(status)) return 'success';
      if (['已使用', '已核销', '已出库', '已销毁'].includes(status)) return 'warning';
      if (['已过期', '已注销', '已冻结', '无效', '停用'].includes(status)) return 'danger';
      return 'info';
    },
    async handleRetryUpload() {
      if (!this.needUploadTraceCode) { this.$message.info('本次无需上传追溯码'); return; }
      this.uploadRetryCount = (this.uploadRetryCount || 0) + 1;
      if (this.uploadRetryCount > 3) { this.$message.warning('重试次数过多，请稍后再试'); return; }
      try {
        this.traceCodeHasError = false;
        this.showRetryButton = false;
        this.msfxUploading = true;
        this.addTraceCodeUploadDetail(`第 ${this.uploadRetryCount} 次重试上传追溯码...`, 'info');
        await this.extractTraceCodes();
        if (!this.traceCodeCount) {
          this.addTraceCodeUploadDetail('没有有效的追溯码需要上传', 'warning');
          this.msfxUploadSuccess = true;
          return;
        }
        const result = await this.uploadTraceCodes();
        if (result.success) {
          this.addTraceCodeUploadDetail('重试上传成功', 'success');
          this.msfxUploadSuccess = true;
        } else {
          this.addTraceCodeUploadDetail(`重试上传失败: ${result.message}`, 'error');
          this.traceCodeHasError = true;
          this.showRetryButton = true;
          this.msfxUploadSuccess = false;
        }
      } catch (error) {
        console.error('重试上传失败:', error);
        this.traceCodeHasError = true;
        this.showRetryButton = true;
        this.addTraceCodeUploadDetail('重试异常：' + error.message, 'error');
      } finally {
        this.msfxUploading = false;
      }
    },
    updateUnitLabelForm(form) {
      if (!form) return;
      const type = form.stockType !== undefined ? form.stockType : form.purcType;
      if (type === 1) form.unitLabel = form.dosUnt || '';
      else if (type === 2) form.unitLabel = form.pacUnt || '';
      else form.unitLabel = '';
    },
    updateStepProgress() {},
    startProgressAnimation() {},
    stopProgressAnimation() {},
    updateTotalProgress() {},
  }
};
</script>

<style lang="less" scoped>
::v-deep .el-dialog { border-radius: 10px; }
::v-deep .el-dialog__body { padding: 10px; }
::v-deep .el-form-item__label { line-height: 12px; font-weight: 500; }
/* ===== 新增供货单位弹框专属样式（根据截图还原） ===== */
::v-deep .supplier-dialog {
  border-radius: 10px !important;
  overflow: hidden;
}
::v-deep .supplier-dialog .el-dialog__header {
  background-color: #2164b7 !important;
  padding: 12px 20px;
}
::v-deep .supplier-dialog .el-dialog__title {
  color: #fff !important;
  font-size: 15px;
}
::v-deep .supplier-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
::v-deep .supplier-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: #ddd !important;
}
::v-deep .supplier-dialog .el-dialog__body {
  padding: 20px 30px 10px 30px;
}

/* 表单标签和内容的完美对齐 */
::v-deep .supplier-dialog .supplier-form .el-form-item {
  margin-bottom: 18px;
}
::v-deep .supplier-dialog .supplier-form .el-form-item__label {
  font-weight: normal !important;
  color: #333;
  padding-right: 12px;
  text-align: right;
  line-height: 32px;
}
::v-deep .supplier-dialog .supplier-form .el-form-item__content {
  line-height: 32px;
}
::v-deep .supplier-dialog .supplier-form .el-input-number .el-input__inner {
  text-align: center;
}
::v-deep .supplier-dialog .supplier-form .el-textarea__inner {
  padding-top: 6px;
  font-family: inherit;
}
.addxyk-dialog {
  border-radius: 8px;
  .el-dialog__title { font-size: 16px; color: #333; font-weight: 600; }
  .el-dialog__header { background-color: #ffffff !important; border-bottom: 1px solid #e8e8e8; padding: 12px; }
  .el-dialog__headerbtn .el-dialog__close { color: #606266; }
  .el-dialog__headerbtn .el-dialog__close:hover { color: #409EFF; }

  .section-title {
    font-size: 16px; font-weight: 700; color: #303133;
    margin: 0 0 12px 0; padding-bottom: 6px; display: inline-block; border-bottom: 3px solid #409EFF;
  }
  .basic-info-section {
    margin-bottom: 12px; border-bottom: 1px solid #e8e8e8;
    .section-header {
      margin-bottom: 16px;
      .section-desc { font-size: 12px; color: #606266; margin: 8px 0 0 0; line-height: 1.6; }
    }
    .supplier-wrapper {
      display: flex; align-items: center;
      .add-supplier-btn {
        border-color: #409EFF; color: #409EFF; background-color: #f0f9ff;
        margin-right: 8px; padding: 7px 8px;
        &:hover { background-color: #409EFF; color: white; }
      }
      .supplier-code-input { width: 120px; }
    }
  }
  .medicine-detail-section {
    .section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
  }
  ::v-deep .el-form-item {
    margin-bottom: 8px;
    .el-form-item__label { font-weight: 700; padding-bottom: 2px; }
  }
  .drug-select-container { position: relative; }
  .drug-option {
    display: flex; flex-direction: column; padding: 5px 0; line-height: 1.4;
    .drug-name { font-weight: bold; color: #333; margin-bottom: 2px; }
    .drug-spec {
      font-size: 12px; color: #666; margin-top: 1px;
      &:not(:last-child) { margin-bottom: 1px; }
    }
  }
  .load-more-option, .no-more-option, .loading-option { text-align: center; padding: 8px 0; color: #909399; }
  .qty-wrapper {
    display: flex; align-items: center;
    .qty-input { flex: 1; margin-right: 8px; }
    .unit-label { min-width: 40px; color: #666; font-size: 12px; text-align: left; }
  }
  .summary-info {
    margin-top: 10px; padding: 12px; background-color: #f5f7fa; border-radius: 4px;
    .summary-item {
      display: flex; justify-content: space-between; align-items: center; font-size: 14px;
      .label { color: #606266; }
      .value { color: #409EFF; font-weight: 600; }
    }
  }
}

.drug-select-popper {
  .el-select-dropdown__item {
    height: auto; min-height: 50px; padding: 8px 12px; display: flex; align-items: center;
    &:hover, &.selected, &.hover {
      .drug-option .drug-name .highlight-keyword { color: #ff6700; background-color: rgba(255,103,0,0.15); }
    }
    .drug-option {
      display: flex; flex-direction: column; width: 100%; line-height: 1.4; min-height: 50px;
      .drug-name {
        font-weight: 600; color: #303133; margin-bottom: 3px; font-size: 13px;
        .highlight-keyword {
          color: #ff6700; font-weight: bold; background-color: rgba(255,103,0,0.1);
          padding: 0 2px; border-radius: 2px;
        }
      }
      .drug-spec {
        font-size: 12px; color: #606266; line-height: 1.3;
        &:not(:last-child) { margin-bottom: 2px; }
      }
    }
  }
}

.trace-code-dialog {
  .el-dialog__header { background-color: #f5f7fa !important; border-bottom: 1px solid #ebeef5; }
  .el-dialog__title { color: #303133 !important; font-weight: 600; }
  .el-dialog__body { padding: 0 !important; background-color: #ffffff; }
  .el-dialog__footer { background-color: #ffffff; border-top: 1px solid #ebeef5; padding: 10px 20px; }
}
.trace-code-dialog-content { padding: 20px; }
.function-buttons-section {
  margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px solid #ebeef5;
  .function-button-group {
    display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;
    .left-function-area {
      flex: 1; min-width: 300px; margin-right: 20px;
      .scan-input-area {
        background-color: #f8f9fa; border: 1px solid #ebeef5; border-radius: 4px; padding: 4px;
        .scan-area-title { font-size: 14px; color: #606266; margin-bottom:10px; font-weight:600; }
        .scan-input-wrapper { margin-bottom:8px; }
        .scan-tips { font-size:12px; color:#909399; i { margin-right:5px; } }
      }
    }
    .right-function-area {
      display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap; min-width: 200px;
      .function-button-item {
        display: flex; flex-direction: column; align-items: center; cursor: pointer;
        padding: 10px 15px; border-radius: 4px; transition: all 0.3s; min-width: 80px; margin-left: 10px;
        &:hover { background-color:#f5f7fa; transform:translateY(-2px); }
        &.active { background-color:#ecf5ff; }
        .function-icon { font-size:24px; color:#409EFF; margin-bottom:8px; }
        .function-text { font-size:12px; color:#606266; }
      }
    }
  }
}
.summary-info-section {
  background-color: #f8f9fa; border: 1px solid #ebeef5; border-radius: 4px;
  padding: 15px; margin-bottom: 15px;
  .summary-item {
    display: flex; align-items: center;
    .label { font-size:12px; color:#606266; margin-right:8px; white-space:nowrap; }
    .value { font-size:13px; color:#303133; font-weight:500; &.warning { color:#E6A23C; font-weight:600; } }
  }
}
.trace-code-table-section {
  .trace-code-table {
    /deep/ .el-table {
      border: 1px solid #ebeef5;
      th { background-color:#f5f7fa; font-weight:600; color:#303133; }
      td, th { border-right:1px solid #ebeef5; border-bottom:1px solid #ebeef5; }
    }
  }
}
.trace-code-dialog-footer {
  display: flex; justify-content: flex-end; align-items: center;
  .el-button { margin-left:10px; }
}

.trace-code-upload-dialog {
  .upload-progress-dialog {
    .upload-steps { margin-bottom: 20px; }

    .upload-result-banner {
      margin: 0 auto 16px;
      padding: 10px 20px;
      border-radius: 4px;
      font-size: 14px;
      text-align: center;
      max-width: 100%;

      &.success {
        background-color: #f0f9eb;
        border: 1px solid #c2e7b0;
        color: #67C23A;
        .check-mark { font-weight: bold; margin-left: 4px; font-size: 16px; }
      }

      &.error {
        background-color: #fef0f0;
        border: 1px solid #fbc4c4;
        color: #F56C6C;
        .error-title { font-weight: 600; }
        .error-msg { margin-left: 4px; }
        .result-tip { color: #909399; margin-left: 8px; }
      }

      .result-row {
        display: flex; align-items: center; justify-content: center; gap: 6px;
        i { font-size: 18px; }
      }
    }

    .upload-details {
      margin-top: 20px; border: 1px solid #e6e6e6; border-radius: 4px; padding: 12px;
      .details-title { font-weight: 500; margin-bottom: 8px; color: #303133; }
      .details-content {
        .detail-item {
          padding: 6px 0; border-bottom: 1px solid #f0f0f0;
          display: flex; align-items: center; font-size: 13px;
          &:last-child { border-bottom: none; }
          i { margin-right: 8px; font-size: 16px; }
          .detail-time { margin-left: auto; color: #909399; font-size: 12px; }
          &.success { color: #67C23A; i { color: #67C23A; } }
          &.error { color: #F56C6C; i { color: #F56C6C; } }
          &.warning { color: #E6A23C; i { color: #E6A23C; } }
          &.info { color: #909399; i { color: #909399; } }
        }
      }
    }

    .upload-progress { margin-top: 20px; }
  }
}
</style>